// tslint:disable
/**
 * Enrollment Files API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AWDDetailDto
 */
export interface AWDDetailDto {
    /**
     * 
     * @type {Date}
     * @memberof AWDDetailDto
     */
    createDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AWDDetailDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AWDDetailDto
     */
    statusDetails?: string | null;
}
/**
 * 
 * @export
 * @interface AWDProcessingHistoryDto
 */
export interface AWDProcessingHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof AWDProcessingHistoryDto
     */
    awdSystemID?: string | null;
    /**
     * 
     * @type {Array<AWDDetailDto>}
     * @memberof AWDProcessingHistoryDto
     */
    awdDetails?: Array<AWDDetailDto> | null;
}
/**
 * 
 * @export
 * @interface AccountProfileMetricsDto
 */
export interface AccountProfileMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof AccountProfileMetricsDto
     */
    totalAccountProfile?: number;
}
/**
 * 
 * @export
 * @interface ApplicationDetailDto
 */
export interface ApplicationDetailDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    maskedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    product?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    taskName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    l70Status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    awdStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    bpStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    finalDisposition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDetailDto
     */
    awdSystemID?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationDto
 */
export interface ApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDto
     */
    ssn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationDto
     */
    totalErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationDto
     */
    validationErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationDto
     */
    auditErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationDto
     */
    kickoutValidationErrorCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationDto
     */
    isValid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationDto
     */
    isDuplicate?: boolean;
    /**
     * 
     * @type {EnrollmentRequestType}
     * @memberof ApplicationDto
     */
    requestType?: EnrollmentRequestType | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDto
     */
    step?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationDto
     */
    status?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationProcessingDetailDto
 */
export interface ApplicationProcessingDetailDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationProcessingDetailDto
     */
    taskName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationProcessingDetailDto
     */
    createDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationProcessingDetailDto
     */
    updatedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationProcessingDetailDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationProcessingDetailDto
     */
    additionalDetails?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationProcessingDetailDto
     */
    pendingTask?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationProcessingDetailDto
     */
    completedTask?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationProcessingDetailDto
     */
    totalTask?: number | null;
}
/**
 * 
 * @export
 * @interface B2BCaseDto
 */
export interface B2BCaseDto {
    /**
     * 
     * @type {string}
     * @memberof B2BCaseDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2BCaseDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2BCaseDto
     */
    enrollmentPlatform?: string | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof B2BCaseDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface BrokerSpreadsheetUploadsMetricsDto
 */
export interface BrokerSpreadsheetUploadsMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof BrokerSpreadsheetUploadsMetricsDto
     */
    receivedFilesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BrokerSpreadsheetUploadsMetricsDto
     */
    processingFilesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BrokerSpreadsheetUploadsMetricsDto
     */
    completedFilesCount?: number;
}
/**
 * 
 * @export
 * @interface ChartData
 */
export interface ChartData {
    /**
     * 
     * @type {string}
     * @memberof ChartData
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChartData
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    emailNotification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    contactType?: string | null;
}
/**
 * 
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     * 
     * @type {string}
     * @memberof ContactDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactDto
     */
    emailNotification?: boolean;
}
/**
 * 
 * @export
 * @interface DaysToCompleteTurnAroundChartDetailsDto
 */
export interface DaysToCompleteTurnAroundChartDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof DaysToCompleteTurnAroundChartDetailsDto
     */
    monthName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DaysToCompleteTurnAroundChartDetailsDto
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof DaysToCompleteTurnAroundChartDetailsDto
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DaysToProcessTurnAroundChartDetailsDto
 */
export interface DaysToProcessTurnAroundChartDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof DaysToProcessTurnAroundChartDetailsDto
     */
    displayLabel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DaysToProcessTurnAroundChartDetailsDto
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof DaysToProcessTurnAroundChartDetailsDto
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface EmailDto
 */
export interface EmailDto {
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    caseRequestID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {Array<ContactDto>}
     * @memberof EmailDto
     */
    to?: Array<ContactDto> | null;
    /**
     * 
     * @type {Array<ContactDto>}
     * @memberof EmailDto
     */
    cc?: Array<ContactDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    subject?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmailDto
     */
    isBodyHtml?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    attachment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    attachmentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    body?: string | null;
}
/**
 * 
 * @export
 * @interface EmployeeErrorDetailsDto
 */
export interface EmployeeErrorDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    maskedSSN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    disability?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {EnrollmentRequestType}
     * @memberof EmployeeErrorDetailsDto
     */
    requestType?: EnrollmentRequestType | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    product?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeeErrorDetailsDto
     */
    errorCount?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    errorType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    errors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    auditErrors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    kickoutErrors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    dependentValidationErrors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    dependentAuditErrors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    groupComparisonError?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeErrorDetailsDto
     */
    batchFileCreationErrors?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeeErrorDetailsDto
     */
    dependentValidationErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeErrorDetailsDto
     */
    dependentAuditErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeErrorDetailsDto
     */
    auditErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeErrorDetailsDto
     */
    totalErrorCount?: number;
    /**
     * 
     * @type {Plan}
     * @memberof EmployeeErrorDetailsDto
     */
    plan?: Plan | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeErrorDetailsDto
     */
    ssn?: string | null;
}
/**
 * 
 * @export
 * @interface EmployerDto
 */
export interface EmployerDto {
    /**
     * 
     * @type {string}
     * @memberof EmployerDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployerDto
     */
    identifier?: string | null;
}
/**
 * 
 * @export
 * @interface EmployerEnrollmentDto
 */
export interface EmployerEnrollmentDto {
    /**
     * 
     * @type {string}
     * @memberof EmployerEnrollmentDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    numberOfSuccessfulRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    numberOfInProgressRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    numberOfOutstandingDiscrepancies?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    numberOfDiscrepancies?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    ageOfOldestOutstandingDiscrepancyInDays?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerEnrollmentDto
     */
    ageOfOldestOutstandingDiscrepancyInFractionalDays?: number;
}
/**
 * 
 * @export
 * @interface EmployerFileType
 */
export interface EmployerFileType extends Enumeration {
}
/**
 * 
 * @export
 * @interface EmployerProfileDto
 */
export interface EmployerProfileDto {
    /**
     * 
     * @type {number}
     * @memberof EmployerProfileDto
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerProfileDto
     */
    successfulRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EmployerProfileDto
     */
    unsuccessfulRecords?: number;
    /**
     * 
     * @type {string}
     * @memberof EmployerProfileDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {EmployerFileType}
     * @memberof EmployerProfileDto
     */
    fileType?: EmployerFileType | null;
    /**
     * 
     * @type {Date}
     * @memberof EmployerProfileDto
     */
    fileUploadedDate?: Date | null;
}
/**
 * 
 * @export
 * @interface EmployerProfileSaveCommand
 */
export interface EmployerProfileSaveCommand {
    /**
     * 
     * @type {string}
     * @memberof EmployerProfileSaveCommand
     */
    filePath?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollmentApplication
 */
export interface EnrollmentApplication {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    id?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof EnrollmentApplication
     */
    domainEvents?: Array<object> | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    ssn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    product?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    rejectReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentApplication
     */
    rejectDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplication
     */
    rejectedBy?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollmentApplicationAllOf
 */
export interface EnrollmentApplicationAllOf {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    ssn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    product?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    rejectReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentApplicationAllOf
     */
    rejectDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentApplicationAllOf
     */
    rejectedBy?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollmentDiscrepancyDetailDto
 */
export interface EnrollmentDiscrepancyDetailDto {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    ssn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    product?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    attempts?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentDiscrepancyDetailDto
     */
    ageOfUnsuccessfullInDays?: number;
}
/**
 * 
 * @export
 * @interface EnrollmentFileAcceptanceStatus
 */
export interface EnrollmentFileAcceptanceStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface EnrollmentFileAuditDetailDto
 */
export interface EnrollmentFileAuditDetailDto {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileAuditDetailDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileAuditDetailDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFileAuditDetailDto
     */
    createDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    accountStructureMismatches?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    productMismatches?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    auditCoverageMismatches?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    auditNonCoverageMismatches?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    policyMismatches?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    policyMatches?: number;
    /**
     * 
     * @type {EnrollmentFileStatus}
     * @memberof EnrollmentFileAuditDetailDto
     */
    fileStatus?: EnrollmentFileStatus | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileAuditDetailDto
     */
    invalidSSNCount?: number;
}
/**
 * 
 * @export
 * @interface EnrollmentFileProcessOption
 */
export interface EnrollmentFileProcessOption extends Enumeration {
}
/**
 * 
 * @export
 * @interface EnrollmentFileRecordValidationDto
 */
export interface EnrollmentFileRecordValidationDto {
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageTerminationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageElectionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageChangeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageElectionSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageElectionUnsuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    reinstatementCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    adminChangeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    nonCoverageDemographicChangeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    nonCoverageDemographicChangeSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    nonCoverageDemographicChangeUnsuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    noChangesDetectedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    terminationSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    terminationUnSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageChangeSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    coverageChangeUnSuccessfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileRecordValidationDto
     */
    undeterminedCount?: number;
}
/**
 * 
 * @export
 * @interface EnrollmentFileSaveCommand
 */
export interface EnrollmentFileSaveCommand {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    fileSize?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    filePath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileSaveCommand
     */
    rowCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    fileType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFileSaveCommand
     */
    timeStamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFileSaveCommand
     */
    templateId?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    uploadedByUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    uploadedByUserEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    uploadedByFirstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    uploadedByLastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFileSaveCommand
     */
    agreementAcceptedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    fileStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    agreementAcceptedDateKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFileSaveCommand
     */
    groupId?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollmentFileStatus
 */
export interface EnrollmentFileStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface EnrollmentFileTemplateType
 */
export interface EnrollmentFileTemplateType extends Enumeration {
}
/**
 * 
 * @export
 * @interface EnrollmentFilesDetailDto
 */
export interface EnrollmentFilesDetailDto {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    fileSize?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    filePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    fileType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    groupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    uploadedByUserName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    rowCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    validRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    invalidRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    validAuditCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    invalidAuditCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    groupWebComparisonErrorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    batchFileErrorCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    groupWebComparisonCompleteDate?: Date | null;
    /**
     * 
     * @type {EnrollmentFileStatus}
     * @memberof EnrollmentFilesDetailDto
     */
    fileStatus?: EnrollmentFileStatus | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    fileUploadedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentFilesDetailDto
     */
    fileStatusIdBeforeCanceled?: number;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    fileStatusChangedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    fileCanceledDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    recentActionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    fileCanceledReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    returnComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentFilesDetailDto
     */
    fileProcessReason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentFilesDetailDto
     */
    isCanceled?: boolean;
    /**
     * 
     * @type {EnrollmentFileTemplateType}
     * @memberof EnrollmentFilesDetailDto
     */
    templateType?: EnrollmentFileTemplateType | null;
    /**
     * 
     * @type {Array<EmployeeErrorDetailsDto>}
     * @memberof EnrollmentFilesDetailDto
     */
    employeeErrorDetails?: Array<EmployeeErrorDetailsDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    validationCompletedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentFilesDetailDto
     */
    processingCompletedDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentFilesDetailDto
     */
    isValidRecord?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentFilesDetailDto
     */
    batchHasReGenerated?: boolean;
    /**
     * 
     * @type {Array<Date>}
     * @memberof EnrollmentFilesDetailDto
     */
    batchReGeneratoinDateHistory?: Array<Date> | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof EnrollmentFilesDetailDto
     */
    batchReAuditDateHistory?: Array<Date> | null;
}
/**
 * 
 * @export
 * @interface EnrollmentRequestType
 */
export interface EnrollmentRequestType extends Enumeration {
}
/**
 * 
 * @export
 * @interface EnrollmentRequestTypeDto
 */
export interface EnrollmentRequestTypeDto {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentRequestTypeDto
     */
    requestType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentRequestTypeDto
     */
    numberOfSuccessfulRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentRequestTypeDto
     */
    numberOfPendingRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentRequestTypeDto
     */
    numberOfUnsuccessfulRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentRequestTypeDto
     */
    totalRecords?: number;
}
/**
 * 
 * @export
 * @interface EnrollmentStatusDto
 */
export interface EnrollmentStatusDto {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentStatusDto
     */
    productType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentStatusDto
     */
    totalRecords?: number;
    /**
     * 
     * @type {Array<EnrollmentRequestTypeDto>}
     * @memberof EnrollmentStatusDto
     */
    enrollmentRequestTypeDto?: Array<EnrollmentRequestTypeDto> | null;
}
/**
 * 
 * @export
 * @interface EnrollmentTask
 */
export interface EnrollmentTask {
    /**
     * 
     * @type {number}
     * @memberof EnrollmentTask
     */
    actualDays?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentTask
     */
    processingStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentTask
     */
    isValidation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentTask
     */
    slaStatus?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollmentTaskAllOf
 */
export interface EnrollmentTaskAllOf {
    /**
     * 
     * @type {number}
     * @memberof EnrollmentTaskAllOf
     */
    actualDays?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentTaskAllOf
     */
    processingStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentTaskAllOf
     */
    isValidation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentTaskAllOf
     */
    slaStatus?: string | null;
}
/**
 * 
 * @export
 * @interface Entity
 */
export interface Entity {
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    id?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof Entity
     */
    domainEvents?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface ExternalUploadEnrollmentFileDetailsDto
 */
export interface ExternalUploadEnrollmentFileDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    returnComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    removalReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    actionName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    actionDateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    actionBy?: string | null;
    /**
     * 
     * @type {EnrollmentFileProcessOption}
     * @memberof ExternalUploadEnrollmentFileDetailsDto
     */
    processReason?: EnrollmentFileProcessOption | null;
}
/**
 * 
 * @export
 * @interface ExternalUploadEnrollmentFileDto
 */
export interface ExternalUploadEnrollmentFileDto {
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    fileType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    fileUploadedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    uploadedByUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    uploadedByFirstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    uploadedByLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    uploadedByEmail?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    recordCount?: number | null;
    /**
     * 
     * @type {EnrollmentFileStatus}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    fileStatus?: EnrollmentFileStatus | null;
    /**
     * 
     * @type {EnrollmentFileProcessOption}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    processReason?: EnrollmentFileProcessOption | null;
    /**
     * 
     * @type {Date}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    recentActionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    returnComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUploadEnrollmentFileDto
     */
    removalReason?: string | null;
}
/**
 * 
 * @export
 * @interface FileFeedbackMetricsDto
 */
export interface FileFeedbackMetricsDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof FileFeedbackMetricsDto
     */
    fileFeedback?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface FileProfileMetricsDto
 */
export interface FileProfileMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof FileProfileMetricsDto
     */
    totalFileProfile?: number;
}
/**
 * 
 * @export
 * @interface FileSystemNotificationDto
 */
export interface FileSystemNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationDto
     */
    changeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationDto
     */
    fullPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationDto
     */
    oldFullPath?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FileSystemNotificationDto
     */
    timeStamp?: Date;
}
/**
 * 
 * @export
 * @interface FileSystemNotificationReportDto
 */
export interface FileSystemNotificationReportDto {
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    fileProfileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    fileHistoryId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FileSystemNotificationReportDto
     */
    fileReceivedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FileSystemNotificationReportDto
     */
    fileSavedDate?: Date;
    /**
     * 
     * @type {EnrollmentFileAcceptanceStatus}
     * @memberof FileSystemNotificationReportDto
     */
    fileAcceptanceStatus?: EnrollmentFileAcceptanceStatus | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    scheduleHistoryStatus?: string | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof FileSystemNotificationReportDto
     */
    links?: Array<Link> | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    filePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    folderPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileSystemNotificationReportDto
     */
    relativeFilePath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileSystemNotificationReportDto
     */
    notesCount?: number;
    /**
     * 
     * @type {Array<NotesDto>}
     * @memberof FileSystemNotificationReportDto
     */
    notes?: Array<NotesDto> | null;
}
/**
 * 
 * @export
 * @interface FileTrackingMonitorMetricsDto
 */
export interface FileTrackingMonitorMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof FileTrackingMonitorMetricsDto
     */
    totalFileTrackingMonitor?: number;
}
/**
 * 
 * @export
 * @interface FileVolumeChartDetailsDto
 */
export interface FileVolumeChartDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof FileVolumeChartDetailsDto
     */
    displayLabel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileVolumeChartDetailsDto
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof FileVolumeChartDetailsDto
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface FilesNotProcessedMetricsDto
 */
export interface FilesNotProcessedMetricsDto {
    /**
     * 
     * @type {number}
     * @memberof FilesNotProcessedMetricsDto
     */
    filesNotProcessed?: number;
}
/**
 * 
 * @export
 * @interface GenelcoBatchFileDto
 */
export interface GenelcoBatchFileDto {
    /**
     * 
     * @type {Date}
     * @memberof GenelcoBatchFileDto
     */
    batchFileCreationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GenelcoBatchFileDto
     */
    destinationFolder?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GenelcoBatchFileDto
     */
    applicationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GenelcoBatchFileDto
     */
    failedApplicationCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof GenelcoBatchFileDto
     */
    lastBatch?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GenelcoBatchFileDto
     */
    lastAudit?: Date | null;
    /**
     * 
     * @type {EnrollmentFileStatus}
     * @memberof GenelcoBatchFileDto
     */
    fileStatus?: EnrollmentFileStatus | null;
}
/**
 * 
 * @export
 * @interface GetEmailRequestDto
 */
export interface GetEmailRequestDto {
    /**
     * 
     * @type {RejectDetailApplicationDto}
     * @memberof GetEmailRequestDto
     */
    rejectApplications?: RejectDetailApplicationDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailRequestDto
     */
    emailHistoryId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailRequestDto
     */
    isResend?: boolean;
}
/**
 * 
 * @export
 * @interface LifeCycleReportChartDetailsDto
 */
export interface LifeCycleReportChartDetailsDto {
    /**
     * 
     * @type {Array<FileVolumeChartDetailsDto>}
     * @memberof LifeCycleReportChartDetailsDto
     */
    fileVolumesChart?: Array<FileVolumeChartDetailsDto> | null;
    /**
     * 
     * @type {Array<DaysToProcessTurnAroundChartDetailsDto>}
     * @memberof LifeCycleReportChartDetailsDto
     */
    daysToProcessTurnAroundChart?: Array<DaysToProcessTurnAroundChartDetailsDto> | null;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface Metrics
 */
export interface Metrics {
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    totalCases?: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    criticalCases?: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    warningCases?: number;
    /**
     * 
     * @type {number}
     * @memberof Metrics
     */
    okCases?: number;
}
/**
 * 
 * @export
 * @interface NotesDto
 */
export interface NotesDto {
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    fileProfileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    noteType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    noteSubType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    noteText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotesDto
     */
    modifiedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof NotesDto
     */
    modifiedDate?: Date;
}
/**
 * 
 * @export
 * @interface PagedB2BCase
 */
export interface PagedB2BCase extends PagedResultOfB2BCaseDto {
}
/**
 * 
 * @export
 * @interface PagedEmwProcessingHistory
 */
export interface PagedEmwProcessingHistory extends PagedResultOfProcessingHistoryEmwDto {
}
/**
 * 
 * @export
 * @interface PagedEsrProcessingHistory
 */
export interface PagedEsrProcessingHistory extends PagedResultOfProcessingHistoryEsrDto {
}
/**
 * 
 * @export
 * @interface PagedExternalUploadQueue
 */
export interface PagedExternalUploadQueue extends PagedResultOfExternalUploadEnrollmentFileDto {
}
/**
 * 
 * @export
 * @interface PagedExternalUploadQueueDetails
 */
export interface PagedExternalUploadQueueDetails extends PagedResultOfExternalUploadEnrollmentFileDetailsDto {
}
/**
 * 
 * @export
 * @interface PagedPendingProcessingHistory
 */
export interface PagedPendingProcessingHistory extends PagedResultOfFileSystemNotificationReportDto {
}
/**
 * 
 * @export
 * @interface PagedProcessingHistoryEsrAppDetailDto
 */
export interface PagedProcessingHistoryEsrAppDetailDto extends PagedResultOfApplicationDetailDto {
}
/**
 * 
 * @export
 * @interface PagedRejectHistory
 */
export interface PagedRejectHistory extends PagedResultOfRejectHistoryDto {
}
/**
 * 
 * @export
 * @interface PagedResultOfApplicationDetailDto
 */
export interface PagedResultOfApplicationDetailDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfApplicationDetailDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfApplicationDetailDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<ApplicationDetailDto>}
     * @memberof PagedResultOfApplicationDetailDto
     */
    result?: Array<ApplicationDetailDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfApplicationDetailDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfB2BCaseDto
 */
export interface PagedResultOfB2BCaseDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfB2BCaseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfB2BCaseDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<B2BCaseDto>}
     * @memberof PagedResultOfB2BCaseDto
     */
    result?: Array<B2BCaseDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfB2BCaseDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfEmployerEnrollmentDto
 */
export interface PagedResultOfEmployerEnrollmentDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEmployerEnrollmentDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEmployerEnrollmentDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<EmployerEnrollmentDto>}
     * @memberof PagedResultOfEmployerEnrollmentDto
     */
    result?: Array<EmployerEnrollmentDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfEmployerEnrollmentDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfEmployerProfileDto
 */
export interface PagedResultOfEmployerProfileDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEmployerProfileDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEmployerProfileDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<EmployerProfileDto>}
     * @memberof PagedResultOfEmployerProfileDto
     */
    result?: Array<EmployerProfileDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfEmployerProfileDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfEnrollmentDiscrepancyDetailDto
 */
export interface PagedResultOfEnrollmentDiscrepancyDetailDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEnrollmentDiscrepancyDetailDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEnrollmentDiscrepancyDetailDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<EnrollmentDiscrepancyDetailDto>}
     * @memberof PagedResultOfEnrollmentDiscrepancyDetailDto
     */
    result?: Array<EnrollmentDiscrepancyDetailDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfEnrollmentDiscrepancyDetailDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfEnrollmentFilesDetailDto
 */
export interface PagedResultOfEnrollmentFilesDetailDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEnrollmentFilesDetailDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfEnrollmentFilesDetailDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<EnrollmentFilesDetailDto>}
     * @memberof PagedResultOfEnrollmentFilesDetailDto
     */
    result?: Array<EnrollmentFilesDetailDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfEnrollmentFilesDetailDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfExternalUploadEnrollmentFileDetailsDto
 */
export interface PagedResultOfExternalUploadEnrollmentFileDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDetailsDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDetailsDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<ExternalUploadEnrollmentFileDetailsDto>}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDetailsDto
     */
    result?: Array<ExternalUploadEnrollmentFileDetailsDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDetailsDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfExternalUploadEnrollmentFileDto
 */
export interface PagedResultOfExternalUploadEnrollmentFileDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<ExternalUploadEnrollmentFileDto>}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDto
     */
    result?: Array<ExternalUploadEnrollmentFileDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfExternalUploadEnrollmentFileDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfFileSystemNotificationReportDto
 */
export interface PagedResultOfFileSystemNotificationReportDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfFileSystemNotificationReportDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfFileSystemNotificationReportDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<FileSystemNotificationReportDto>}
     * @memberof PagedResultOfFileSystemNotificationReportDto
     */
    result?: Array<FileSystemNotificationReportDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfFileSystemNotificationReportDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfGenelcoBatchFileDto
 */
export interface PagedResultOfGenelcoBatchFileDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfGenelcoBatchFileDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfGenelcoBatchFileDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<GenelcoBatchFileDto>}
     * @memberof PagedResultOfGenelcoBatchFileDto
     */
    result?: Array<GenelcoBatchFileDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfGenelcoBatchFileDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfProcessingHistoryEmwDto
 */
export interface PagedResultOfProcessingHistoryEmwDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProcessingHistoryEmwDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProcessingHistoryEmwDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<ProcessingHistoryEmwDto>}
     * @memberof PagedResultOfProcessingHistoryEmwDto
     */
    result?: Array<ProcessingHistoryEmwDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfProcessingHistoryEmwDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfProcessingHistoryEsrDto
 */
export interface PagedResultOfProcessingHistoryEsrDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProcessingHistoryEsrDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfProcessingHistoryEsrDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<ProcessingHistoryEsrDto>}
     * @memberof PagedResultOfProcessingHistoryEsrDto
     */
    result?: Array<ProcessingHistoryEsrDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfProcessingHistoryEsrDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfRejectApplicationDto
 */
export interface PagedResultOfRejectApplicationDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectApplicationDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectApplicationDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<RejectApplicationDto>}
     * @memberof PagedResultOfRejectApplicationDto
     */
    result?: Array<RejectApplicationDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfRejectApplicationDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfRejectEmailHistoryDto
 */
export interface PagedResultOfRejectEmailHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectEmailHistoryDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectEmailHistoryDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<RejectEmailHistoryDto>}
     * @memberof PagedResultOfRejectEmailHistoryDto
     */
    result?: Array<RejectEmailHistoryDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfRejectEmailHistoryDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfRejectHistoryDetailDto
 */
export interface PagedResultOfRejectHistoryDetailDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectHistoryDetailDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectHistoryDetailDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<RejectHistoryDetailDto>}
     * @memberof PagedResultOfRejectHistoryDetailDto
     */
    result?: Array<RejectHistoryDetailDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfRejectHistoryDetailDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfRejectHistoryDto
 */
export interface PagedResultOfRejectHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectHistoryDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfRejectHistoryDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<RejectHistoryDto>}
     * @memberof PagedResultOfRejectHistoryDto
     */
    result?: Array<RejectHistoryDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfRejectHistoryDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PendingEnrollmentFileStatusDto
 */
export interface PendingEnrollmentFileStatusDto {
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentFileStatusDto
     */
    fileHistoryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentFileStatusDto
     */
    sourceFileCreateDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentFileStatusDto
     */
    fileHistoryStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentFileStatusDto
     */
    scheduleHistoryStatus?: string | null;
}
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    accident?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    cancer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    criticalIllness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    hospital?: string | null;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    instance?: string | null;
    /**
     * 
     * @type {{ [key: string]: AnyType; }}
     * @memberof ProblemDetails
     */
    extensions?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string | null;
}
/**
 * 
 * @export
 * @interface ProcessingHistoryChartDetailsDto
 */
export interface ProcessingHistoryChartDetailsDto {
    /**
     * 
     * @type {Array<ChartData>}
     * @memberof ProcessingHistoryChartDetailsDto
     */
    chart?: Array<ChartData> | null;
}
/**
 * 
 * @export
 * @interface ProcessingHistoryEmwDto
 */
export interface ProcessingHistoryEmwDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    id?: string | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ProcessingHistoryEmwDto
     */
    links?: Array<Link> | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    caseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    businessStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    itStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    enrollmentPeriodId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    enrollmentPeriodName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEmwDto
     */
    agencyName?: string | null;
    /**
     * 
     * @type {Array<EnrollmentTask>}
     * @memberof ProcessingHistoryEmwDto
     */
    tasks?: Array<EnrollmentTask> | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEmwDto
     */
    itMaxDaysTook?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEmwDto
     */
    businessMaxDaysTook?: number | null;
}
/**
 * 
 * @export
 * @interface ProcessingHistoryEsrDto
 */
export interface ProcessingHistoryEsrDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    caseRequestID?: number | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ProcessingHistoryEsrDto
     */
    links?: Array<Link> | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessingHistoryEsrDto
     */
    createdDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    totalApps?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    rejectApps?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    businessStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    itStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryEsrDto
     */
    agencyName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    totalPendingApplications?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    totalSuccessfulApplications?: number | null;
    /**
     * 
     * @type {Array<EnrollmentTask>}
     * @memberof ProcessingHistoryEsrDto
     */
    tasks?: Array<EnrollmentTask> | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    itMaxDaysTook?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    businessMaxDaysTook?: number | null;
    /**
     * 
     * @type {Array<EnrollmentApplication>}
     * @memberof ProcessingHistoryEsrDto
     */
    applications?: Array<EnrollmentApplication> | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    discrepancyCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    numberOfDaysToProcess?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessingHistoryEsrDto
     */
    numberOfDaysToComplete?: number | null;
}
/**
 * 
 * @export
 * @interface ProcessingHistoryMetricsDto
 */
export interface ProcessingHistoryMetricsDto {
    /**
     * 
     * @type {Metrics}
     * @memberof ProcessingHistoryMetricsDto
     */
    emwMetrics?: Metrics | null;
    /**
     * 
     * @type {Metrics}
     * @memberof ProcessingHistoryMetricsDto
     */
    esrMetrics?: Metrics | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProcessingHistoryMetricsDto
     */
    enrollTrackRejectedFiles?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface ProcessingHistoryStatusCommand
 */
export interface ProcessingHistoryStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof ProcessingHistoryStatusCommand
     */
    fileName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessingHistoryStatusCommand
     */
    notificationDate?: Date;
}
/**
 * 
 * @export
 * @interface RejectApplicationDto
 */
export interface RejectApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    maskedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    product?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    rejectReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    rejectedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectApplicationDto
     */
    rejectDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof RejectApplicationDto
     */
    isIncludedInEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RejectApplicationDto
     */
    applicationSource?: string | null;
}
/**
 * 
 * @export
 * @interface RejectDetailApplicationDto
 */
export interface RejectDetailApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof RejectDetailApplicationDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectDetailApplicationDto
     */
    applicationSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectDetailApplicationDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {Array<RejectApplicationDto>}
     * @memberof RejectDetailApplicationDto
     */
    applications?: Array<RejectApplicationDto> | null;
}
/**
 * 
 * @export
 * @interface RejectEmailHistoryDto
 */
export interface RejectEmailHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof RejectEmailHistoryDto
     */
    caseRequestID?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    body?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    attachment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    attachmentName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectEmailHistoryDto
     */
    sentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RejectEmailHistoryDto
     */
    groupId?: string | null;
    /**
     * 
     * @type {Array<Contact>}
     * @memberof RejectEmailHistoryDto
     */
    to?: Array<Contact> | null;
    /**
     * 
     * @type {Array<Contact>}
     * @memberof RejectEmailHistoryDto
     */
    cc?: Array<Contact> | null;
}
/**
 * 
 * @export
 * @interface RejectFileProfileDto
 */
export interface RejectFileProfileDto {
    /**
     * 
     * @type {string}
     * @memberof RejectFileProfileDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectFileProfileDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectFileProfileDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectFileProfileDto
     */
    employerId?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectFileProfileDto
     */
    technologyPartner?: string | null;
}
/**
 * 
 * @export
 * @interface RejectHistoryDetailDto
 */
export interface RejectHistoryDetailDto {
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RejectHistoryDetailDto
     */
    caseRequestID?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectHistoryDetailDto
     */
    createdDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    agencyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDetailDto
     */
    applicationSource?: string | null;
    /**
     * 
     * @type {Array<RejectApplicationDto>}
     * @memberof RejectHistoryDetailDto
     */
    applications?: Array<RejectApplicationDto> | null;
}
/**
 * 
 * @export
 * @interface RejectHistoryDto
 */
export interface RejectHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    fileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    checkSum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    technologyPartner?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectHistoryDto
     */
    evaluationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RejectHistoryDto
     */
    caseRequestID?: number;
    /**
     * 
     * @type {number}
     * @memberof RejectHistoryDto
     */
    totalApps?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RejectHistoryDto
     */
    enrollTrackRejectApps?: number | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof RejectHistoryDto
     */
    links?: Array<Link> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RejectHistoryDto
     */
    isEmailSent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RejectHistoryDto
     */
    isEnrollmentFileRejectDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    deleteReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectHistoryDto
     */
    deleteDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RejectHistoryDto
     */
    mostRecentSentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    rejectedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectHistoryDto
     */
    applicationSource?: string | null;
}
/**
 * 
 * @export
 * @interface SendEmailCommand
 */
export interface SendEmailCommand {
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    caseRequestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    fileId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendEmailCommand
     */
    to?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    sentByUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    sentByFirstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    sentByLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    emailId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    groupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailCommand
     */
    applicationSource: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SendEmailCommand
     */
    isResend?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendEmailCommand
     */
    cc?: Array<string> | null;
    /**
     * 
     * @type {Array<RejectApplicationDto>}
     * @memberof SendEmailCommand
     */
    rejectApplications?: Array<RejectApplicationDto> | null;
}
/**
 * 
 * @export
 * @interface TotalRecordsChartDetailsDto
 */
export interface TotalRecordsChartDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof TotalRecordsChartDetailsDto
     */
    monthName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TotalRecordsChartDetailsDto
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalRecordsChartDetailsDto
     */
    count?: number | null;
}

/**
 * AWDStatusLogApi - axios parameter creator
 * @export
 */
export const AWDStatusLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aWDStatusLogAWDStatusETLReset: async (version: string, isPartial?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling aWDStatusLogAWDStatusETLReset.');
            }
            const localVarPath = `/api/v{version}/awdStatusLog/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (isPartial !== undefined) {
                localVarQueryParameter['isPartial'] = isPartial;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AWDStatusLogApi - functional programming interface
 * @export
 */
export const AWDStatusLogApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aWDStatusLogAWDStatusETLReset(version: string, isPartial?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AWDStatusLogApiAxiosParamCreator(configuration).aWDStatusLogAWDStatusETLReset(version, isPartial, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AWDStatusLogApi - factory interface
 * @export
 */
export const AWDStatusLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aWDStatusLogAWDStatusETLReset(version: string, isPartial?: boolean, options?: any): AxiosPromise<void> {
            return AWDStatusLogApiFp(configuration).aWDStatusLogAWDStatusETLReset(version, isPartial, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AWDStatusLogApi - object-oriented interface
 * @export
 * @class AWDStatusLogApi
 * @extends {BaseAPI}
 */
export class AWDStatusLogApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {boolean} [isPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWDStatusLogApi
     */
    public aWDStatusLogAWDStatusETLReset(version: string, isPartial?: boolean, options?: any) {
        return AWDStatusLogApiFp(this.configuration).aWDStatusLogAWDStatusETLReset(version, isPartial, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AccountProfileApi - axios parameter creator
 * @export
 */
export const AccountProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProfileGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountProfileGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/accountProfile/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountProfileApi - functional programming interface
 * @export
 */
export const AccountProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountProfileGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountProfileMetricsDto>> {
            const localVarAxiosArgs = await AccountProfileApiAxiosParamCreator(configuration).accountProfileGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountProfileApi - factory interface
 * @export
 */
export const AccountProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProfileGet(version: string, options?: any): AxiosPromise<AccountProfileMetricsDto> {
            return AccountProfileApiFp(configuration).accountProfileGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountProfileApi - object-oriented interface
 * @export
 * @class AccountProfileApi
 * @extends {BaseAPI}
 */
export class AccountProfileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountProfileApi
     */
    public accountProfileGet(version: string, options?: any) {
        return AccountProfileApiFp(this.configuration).accountProfileGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ApplicationApi - axios parameter creator
 * @export
 */
export const ApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationApplicationETL: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling applicationApplicationETL.');
            }
            const localVarPath = `/api/v{version}/application/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationPrepareApplicationsForEtlReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling applicationPrepareApplicationsForEtlReset.');
            }
            const localVarPath = `/api/v{version}/application/etl/setup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationApi - functional programming interface
 * @export
 */
export const ApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationApplicationETL(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ApplicationApiAxiosParamCreator(configuration).applicationApplicationETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationPrepareApplicationsForEtlReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ApplicationApiAxiosParamCreator(configuration).applicationPrepareApplicationsForEtlReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApplicationApi - factory interface
 * @export
 */
export const ApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationApplicationETL(version: string, options?: any): AxiosPromise<void> {
            return ApplicationApiFp(configuration).applicationApplicationETL(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationPrepareApplicationsForEtlReset(version: string, options?: any): AxiosPromise<void> {
            return ApplicationApiFp(configuration).applicationPrepareApplicationsForEtlReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
export class ApplicationApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationApplicationETL(version: string, options?: any) {
        return ApplicationApiFp(this.configuration).applicationApplicationETL(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationPrepareApplicationsForEtlReset(version: string, options?: any) {
        return ApplicationApiFp(this.configuration).applicationPrepareApplicationsForEtlReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ApplicationProcessingDetailsApi - axios parameter creator
 * @export
 */
export const ApplicationProcessingDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationProcessingDetailsGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling applicationProcessingDetailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling applicationProcessingDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/applicationprocessing/esr/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationProcessingDetailsApi - functional programming interface
 * @export
 */
export const ApplicationProcessingDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationProcessingDetailsGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationProcessingDetailDto>> {
            const localVarAxiosArgs = await ApplicationProcessingDetailsApiAxiosParamCreator(configuration).applicationProcessingDetailsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApplicationProcessingDetailsApi - factory interface
 * @export
 */
export const ApplicationProcessingDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationProcessingDetailsGet(id: string, version: string, options?: any): AxiosPromise<ApplicationProcessingDetailDto> {
            return ApplicationProcessingDetailsApiFp(configuration).applicationProcessingDetailsGet(id, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationProcessingDetailsApi - object-oriented interface
 * @export
 * @class ApplicationProcessingDetailsApi
 * @extends {BaseAPI}
 */
export class ApplicationProcessingDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationProcessingDetailsApi
     */
    public applicationProcessingDetailsGet(id: string, version: string, options?: any) {
        return ApplicationProcessingDetailsApiFp(this.configuration).applicationProcessingDetailsGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BrokerSpreadsheetUploadsMetricsApi - axios parameter creator
 * @export
 */
export const BrokerSpreadsheetUploadsMetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerSpreadsheetUploadsMetricsGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling brokerSpreadsheetUploadsMetricsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/brokerspreadsheetuploads/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrokerSpreadsheetUploadsMetricsApi - functional programming interface
 * @export
 */
export const BrokerSpreadsheetUploadsMetricsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brokerSpreadsheetUploadsMetricsGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrokerSpreadsheetUploadsMetricsDto>> {
            const localVarAxiosArgs = await BrokerSpreadsheetUploadsMetricsApiAxiosParamCreator(configuration).brokerSpreadsheetUploadsMetricsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BrokerSpreadsheetUploadsMetricsApi - factory interface
 * @export
 */
export const BrokerSpreadsheetUploadsMetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokerSpreadsheetUploadsMetricsGet(version: string, options?: any): AxiosPromise<BrokerSpreadsheetUploadsMetricsDto> {
            return BrokerSpreadsheetUploadsMetricsApiFp(configuration).brokerSpreadsheetUploadsMetricsGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrokerSpreadsheetUploadsMetricsApi - object-oriented interface
 * @export
 * @class BrokerSpreadsheetUploadsMetricsApi
 * @extends {BaseAPI}
 */
export class BrokerSpreadsheetUploadsMetricsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrokerSpreadsheetUploadsMetricsApi
     */
    public brokerSpreadsheetUploadsMetricsGet(version: string, options?: any) {
        return BrokerSpreadsheetUploadsMetricsApiFp(this.configuration).brokerSpreadsheetUploadsMetricsGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CaseETLApi - axios parameter creator
 * @export
 */
export const CaseETLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseETLB2BCaseETL: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling caseETLB2BCaseETL.');
            }
            const localVarPath = `/api/v{version}/b2bCase/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseETLB2BCaseETLReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling caseETLB2BCaseETLReset.');
            }
            const localVarPath = `/api/v{version}/b2bCase/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseETLApi - functional programming interface
 * @export
 */
export const CaseETLApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseETLB2BCaseETL(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CaseETLApiAxiosParamCreator(configuration).caseETLB2BCaseETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseETLB2BCaseETLReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CaseETLApiAxiosParamCreator(configuration).caseETLB2BCaseETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaseETLApi - factory interface
 * @export
 */
export const CaseETLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseETLB2BCaseETL(version: string, options?: any): AxiosPromise<void> {
            return CaseETLApiFp(configuration).caseETLB2BCaseETL(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseETLB2BCaseETLReset(version: string, options?: any): AxiosPromise<void> {
            return CaseETLApiFp(configuration).caseETLB2BCaseETLReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseETLApi - object-oriented interface
 * @export
 * @class CaseETLApi
 * @extends {BaseAPI}
 */
export class CaseETLApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseETLApi
     */
    public caseETLB2BCaseETL(version: string, options?: any) {
        return CaseETLApiFp(this.configuration).caseETLB2BCaseETL(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseETLApi
     */
    public caseETLB2BCaseETLReset(version: string, options?: any) {
        return CaseETLApiFp(this.configuration).caseETLB2BCaseETLReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CaseHistoryApi - axios parameter creator
 * @export
 */
export const CaseHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseHistoryGet: async (version: string, caseNumber?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling caseHistoryGet.');
            }
            const localVarPath = `/api/v{version}/b2bCase/processingHistory/B2BCase`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseHistoryApi - functional programming interface
 * @export
 */
export const CaseHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseHistoryGet(version: string, caseNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedB2BCase>> {
            const localVarAxiosArgs = await CaseHistoryApiAxiosParamCreator(configuration).caseHistoryGet(version, caseNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaseHistoryApi - factory interface
 * @export
 */
export const CaseHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseHistoryGet(version: string, caseNumber?: string, options?: any): AxiosPromise<PagedB2BCase> {
            return CaseHistoryApiFp(configuration).caseHistoryGet(version, caseNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseHistoryApi - object-oriented interface
 * @export
 * @class CaseHistoryApi
 * @extends {BaseAPI}
 */
export class CaseHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [caseNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHistoryApi
     */
    public caseHistoryGet(version: string, caseNumber?: string, options?: any) {
        return CaseHistoryApiFp(this.configuration).caseHistoryGet(version, caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CaseNumberApi - axios parameter creator
 * @export
 */
export const CaseNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseNumberGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling caseNumberGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/geAllCaseNumber`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseNumberApi - functional programming interface
 * @export
 */
export const CaseNumberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseNumberGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await CaseNumberApiAxiosParamCreator(configuration).caseNumberGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaseNumberApi - factory interface
 * @export
 */
export const CaseNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseNumberGet(version: string, options?: any): AxiosPromise<Array<string>> {
            return CaseNumberApiFp(configuration).caseNumberGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseNumberApi - object-oriented interface
 * @export
 * @class CaseNumberApi
 * @extends {BaseAPI}
 */
export class CaseNumberApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNumberApi
     */
    public caseNumberGet(version: string, options?: any) {
        return CaseNumberApiFp(this.configuration).caseNumberGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ClientOnboardingFileProfileApi - axios parameter creator
 * @export
 */
export const ClientOnboardingFileProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientOnboardingFileProfileGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling clientOnboardingFileProfileGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileProfile/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientOnboardingFileProfileApi - functional programming interface
 * @export
 */
export const ClientOnboardingFileProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientOnboardingFileProfileGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileProfileMetricsDto>> {
            const localVarAxiosArgs = await ClientOnboardingFileProfileApiAxiosParamCreator(configuration).clientOnboardingFileProfileGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientOnboardingFileProfileApi - factory interface
 * @export
 */
export const ClientOnboardingFileProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientOnboardingFileProfileGet(version: string, options?: any): AxiosPromise<FileProfileMetricsDto> {
            return ClientOnboardingFileProfileApiFp(configuration).clientOnboardingFileProfileGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientOnboardingFileProfileApi - object-oriented interface
 * @export
 * @class ClientOnboardingFileProfileApi
 * @extends {BaseAPI}
 */
export class ClientOnboardingFileProfileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOnboardingFileProfileApi
     */
    public clientOnboardingFileProfileGet(version: string, options?: any) {
        return ClientOnboardingFileProfileApiFp(this.configuration).clientOnboardingFileProfileGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DaysToCompleteTurnAroundChartDetailsApi - axios parameter creator
 * @export
 */
export const DaysToCompleteTurnAroundChartDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daysToCompleteTurnAroundChartDetailsGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling daysToCompleteTurnAroundChartDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/daysToCompleteTurnAroundChart/esr/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DaysToCompleteTurnAroundChartDetailsApi - functional programming interface
 * @export
 */
export const DaysToCompleteTurnAroundChartDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async daysToCompleteTurnAroundChartDetailsGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DaysToCompleteTurnAroundChartDetailsDto>>> {
            const localVarAxiosArgs = await DaysToCompleteTurnAroundChartDetailsApiAxiosParamCreator(configuration).daysToCompleteTurnAroundChartDetailsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DaysToCompleteTurnAroundChartDetailsApi - factory interface
 * @export
 */
export const DaysToCompleteTurnAroundChartDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daysToCompleteTurnAroundChartDetailsGet(version: string, options?: any): AxiosPromise<Array<DaysToCompleteTurnAroundChartDetailsDto>> {
            return DaysToCompleteTurnAroundChartDetailsApiFp(configuration).daysToCompleteTurnAroundChartDetailsGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DaysToCompleteTurnAroundChartDetailsApi - object-oriented interface
 * @export
 * @class DaysToCompleteTurnAroundChartDetailsApi
 * @extends {BaseAPI}
 */
export class DaysToCompleteTurnAroundChartDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DaysToCompleteTurnAroundChartDetailsApi
     */
    public daysToCompleteTurnAroundChartDetailsGet(version: string, options?: any) {
        return DaysToCompleteTurnAroundChartDetailsApiFp(this.configuration).daysToCompleteTurnAroundChartDetailsGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EmailHistoryApi - axios parameter creator
 * @export
 */
export const EmailHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryAuditEmailAttachmentDownload: async (caseRequestIdentifier: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseRequestIdentifier' is not null or undefined
            if (caseRequestIdentifier === null || caseRequestIdentifier === undefined) {
                throw new RequiredError('caseRequestIdentifier','Required parameter caseRequestIdentifier was null or undefined when calling emailHistoryAuditEmailAttachmentDownload.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistoryAuditEmailAttachmentDownload.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{caseRequestIdentifier}/email/audit/attachment`
                .replace(`{${"caseRequestIdentifier"}}`, encodeURIComponent(String(caseRequestIdentifier)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryExportEmail: async (id: number, fileExtension: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling emailHistoryExportEmail.');
            }
            // verify required parameter 'fileExtension' is not null or undefined
            if (fileExtension === null || fileExtension === undefined) {
                throw new RequiredError('fileExtension','Required parameter fileExtension was null or undefined when calling emailHistoryExportEmail.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistoryExportEmail.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{id}/email/export/{fileExtension}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileExtension"}}`, encodeURIComponent(String(fileExtension)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryExportEmailContent: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling emailHistoryExportEmailContent.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistoryExportEmailContent.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{id}/email/content/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {GetEmailRequestDto} getEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryGetEmail: async (version: string, getEmailRequestDto: GetEmailRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistoryGetEmail.');
            }
            // verify required parameter 'getEmailRequestDto' is not null or undefined
            if (getEmailRequestDto === null || getEmailRequestDto === undefined) {
                throw new RequiredError('getEmailRequestDto','Required parameter getEmailRequestDto was null or undefined when calling emailHistoryGetEmail.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/email`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof getEmailRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(getEmailRequestDto !== undefined ? getEmailRequestDto : {}) : (getEmailRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryGetEmailHistory: async (id: string, applicationSource: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('caseRequestIdentifier','Required parameter id was null or undefined when calling emailHistoryGetEmailHistory.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistoryGetEmailHistory.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{id}/{applicationSource}/email/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"applicationSource"}}`, encodeURIComponent(String(applicationSource)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {SendEmailCommand} sendEmailCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistorySendEmail: async (version: string, sendEmailCommand: SendEmailCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling emailHistorySendEmail.');
            }
            // verify required parameter 'sendEmailCommand' is not null or undefined
            if (sendEmailCommand === null || sendEmailCommand === undefined) {
                throw new RequiredError('sendEmailCommand','Required parameter sendEmailCommand was null or undefined when calling emailHistorySendEmail.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/email/send`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sendEmailCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sendEmailCommand !== undefined ? sendEmailCommand : {}) : (sendEmailCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailHistoryApi - functional programming interface
 * @export
 */
export const EmailHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistoryExportEmail(id: number, fileExtension: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistoryExportEmail(id, fileExtension, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistoryExportEmailContent(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistoryExportEmailContent(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {GetEmailRequestDto} getEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistoryGetEmail(version: string, getEmailRequestDto: GetEmailRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailDto>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistoryGetEmail(version, getEmailRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistoryGetEmailHistory(id: string, applicationSource: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfRejectEmailHistoryDto>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistoryGetEmailHistory(id, applicationSource, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {SendEmailCommand} sendEmailCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailHistorySendEmail(version: string, sendEmailCommand: SendEmailCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await EmailHistoryApiAxiosParamCreator(configuration).emailHistorySendEmail(version, sendEmailCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmailHistoryApi - factory interface
 * @export
 */
export const EmailHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier: string, version: string, options?: any): AxiosPromise<void> {
            return EmailHistoryApiFp(configuration).emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryExportEmail(id: number, fileExtension: string, version: string, options?: any): AxiosPromise<any> {
            return EmailHistoryApiFp(configuration).emailHistoryExportEmail(id, fileExtension, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryExportEmailContent(id: string, version: string, options?: any): AxiosPromise<string> {
            return EmailHistoryApiFp(configuration).emailHistoryExportEmailContent(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {GetEmailRequestDto} getEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryGetEmail(version: string, getEmailRequestDto: GetEmailRequestDto, options?: any): AxiosPromise<EmailDto> {
            return EmailHistoryApiFp(configuration).emailHistoryGetEmail(version, getEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseRequestIdentifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistoryGetEmailHistory(id: string, applicationSource: string, version: string, options?: any): AxiosPromise<PagedResultOfRejectEmailHistoryDto> {
            return EmailHistoryApiFp(configuration).emailHistoryGetEmailHistory(id, applicationSource, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {SendEmailCommand} sendEmailCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailHistorySendEmail(version: string, sendEmailCommand: SendEmailCommand, options?: any): AxiosPromise<string> {
            return EmailHistoryApiFp(configuration).emailHistorySendEmail(version, sendEmailCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailHistoryApi - object-oriented interface
 * @export
 * @class EmailHistoryApi
 * @extends {BaseAPI}
 */
export class EmailHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} caseRequestIdentifier 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier: string, version: string, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistoryAuditEmailAttachmentDownload(caseRequestIdentifier, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} fileExtension 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistoryExportEmail(id: number, fileExtension: string, version: string, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistoryExportEmail(id, fileExtension, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistoryExportEmailContent(id: string, version: string, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistoryExportEmailContent(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {GetEmailRequestDto} getEmailRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistoryGetEmail(version: string, getEmailRequestDto: GetEmailRequestDto, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistoryGetEmail(version, getEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseRequestIdentifier 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistoryGetEmailHistory(id: string, applicationSource: string, version: string, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistoryGetEmailHistory(id, applicationSource, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {SendEmailCommand} sendEmailCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryApi
     */
    public emailHistorySendEmail(version: string, sendEmailCommand: SendEmailCommand, options?: any) {
        return EmailHistoryApiFp(this.configuration).emailHistorySendEmail(version, sendEmailCommand, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EmployerApi - axios parameter creator
 * @export
 */
export const EmployerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling employerGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/employers/allEmployers`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployerApi - functional programming interface
 * @export
 */
export const EmployerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployerDto>>> {
            const localVarAxiosArgs = await EmployerApiAxiosParamCreator(configuration).employerGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmployerApi - factory interface
 * @export
 */
export const EmployerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerGet(version: string, options?: any): AxiosPromise<Array<EmployerDto>> {
            return EmployerApiFp(configuration).employerGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployerApi - object-oriented interface
 * @export
 * @class EmployerApi
 * @extends {BaseAPI}
 */
export class EmployerApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployerApi
     */
    public employerGet(version: string, options?: any) {
        return EmployerApiFp(this.configuration).employerGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EmployerProfileApi - axios parameter creator
 * @export
 */
export const EmployerProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EmployerProfileSaveCommand} employerProfileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerProfilePost: async (version: string, employerProfileSaveCommand: EmployerProfileSaveCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling employerProfilePost.');
            }
            // verify required parameter 'employerProfileSaveCommand' is not null or undefined
            if (employerProfileSaveCommand === null || employerProfileSaveCommand === undefined) {
                throw new RequiredError('employerProfileSaveCommand','Required parameter employerProfileSaveCommand was null or undefined when calling employerProfilePost.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/employerProfile`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof employerProfileSaveCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(employerProfileSaveCommand !== undefined ? employerProfileSaveCommand : {}) : (employerProfileSaveCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployerProfileApi - functional programming interface
 * @export
 */
export const EmployerProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EmployerProfileSaveCommand} employerProfileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerProfilePost(version: string, employerProfileSaveCommand: EmployerProfileSaveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EmployerProfileApiAxiosParamCreator(configuration).employerProfilePost(version, employerProfileSaveCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmployerProfileApi - factory interface
 * @export
 */
export const EmployerProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EmployerProfileSaveCommand} employerProfileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerProfilePost(version: string, employerProfileSaveCommand: EmployerProfileSaveCommand, options?: any): AxiosPromise<void> {
            return EmployerProfileApiFp(configuration).employerProfilePost(version, employerProfileSaveCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployerProfileApi - object-oriented interface
 * @export
 * @class EmployerProfileApi
 * @extends {BaseAPI}
 */
export class EmployerProfileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {EmployerProfileSaveCommand} employerProfileSaveCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployerProfileApi
     */
    public employerProfilePost(version: string, employerProfileSaveCommand: EmployerProfileSaveCommand, options?: any) {
        return EmployerProfileApiFp(this.configuration).employerProfilePost(version, employerProfileSaveCommand, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EmployerProfileHistoryApi - axios parameter creator
 * @export
 */
export const EmployerProfileHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerProfileHistoryGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling employerProfileHistoryGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/getEmployerProfiles`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployerProfileHistoryApi - functional programming interface
 * @export
 */
export const EmployerProfileHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employerProfileHistoryGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfEmployerProfileDto>> {
            const localVarAxiosArgs = await EmployerProfileHistoryApiAxiosParamCreator(configuration).employerProfileHistoryGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmployerProfileHistoryApi - factory interface
 * @export
 */
export const EmployerProfileHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employerProfileHistoryGet(version: string, options?: any): AxiosPromise<PagedResultOfEmployerProfileDto> {
            return EmployerProfileHistoryApiFp(configuration).employerProfileHistoryGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployerProfileHistoryApi - object-oriented interface
 * @export
 * @class EmployerProfileHistoryApi
 * @extends {BaseAPI}
 */
export class EmployerProfileHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployerProfileHistoryApi
     */
    public employerProfileHistoryGet(version: string, options?: any) {
        return EmployerProfileHistoryApiFp(this.configuration).employerProfileHistoryGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollMyWayEnrollmentFilesApi - axios parameter creator
 * @export
 */
export const EnrollMyWayEnrollmentFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollMyWayEnrollmentFilesEnrollmentFileETLReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollMyWayEnrollmentFilesEnrollmentFileETLReset.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/enrollMyWayEtl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollMyWayEnrollmentFilesApi - functional programming interface
 * @export
 */
export const EnrollMyWayEnrollmentFilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollMyWayEnrollmentFilesApiAxiosParamCreator(configuration).enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollMyWayEnrollmentFilesApi - factory interface
 * @export
 */
export const EnrollMyWayEnrollmentFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version: string, options?: any): AxiosPromise<void> {
            return EnrollMyWayEnrollmentFilesApiFp(configuration).enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollMyWayEnrollmentFilesApi - object-oriented interface
 * @export
 * @class EnrollMyWayEnrollmentFilesApi
 * @extends {BaseAPI}
 */
export class EnrollMyWayEnrollmentFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollMyWayEnrollmentFilesApi
     */
    public enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version: string, options?: any) {
        return EnrollMyWayEnrollmentFilesApiFp(this.configuration).enrollMyWayEnrollmentFilesEnrollmentFileETLReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentApi - axios parameter creator
 * @export
 */
export const EnrollmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentEnrollmentETL: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentEnrollmentETL.');
            }
            const localVarPath = `/api/v{version}/enrollment/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentEnrollmentETLReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentEnrollmentETLReset.');
            }
            const localVarPath = `/api/v{version}/enrollment/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentExportEmployers: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentExportEmployers.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/enrollment/employers/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentPrepareEnrollmentsForEtlReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentPrepareEnrollmentsForEtlReset.');
            }
            const localVarPath = `/api/v{version}/enrollment/etl/setup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployerEnrollments: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchEmployerEnrollments.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/enrollment/employers`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentApi - functional programming interface
 * @export
 */
export const EnrollmentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentEnrollmentETL(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentApiAxiosParamCreator(configuration).enrollmentEnrollmentETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentEnrollmentETLReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentApiAxiosParamCreator(configuration).enrollmentEnrollmentETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentExportEmployers(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EnrollmentApiAxiosParamCreator(configuration).enrollmentExportEmployers(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentPrepareEnrollmentsForEtlReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentApiAxiosParamCreator(configuration).enrollmentPrepareEnrollmentsForEtlReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEmployerEnrollments(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfEmployerEnrollmentDto>> {
            const localVarAxiosArgs = await EnrollmentApiAxiosParamCreator(configuration).searchEmployerEnrollments(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentApi - factory interface
 * @export
 */
export const EnrollmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentEnrollmentETL(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentApiFp(configuration).enrollmentEnrollmentETL(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentEnrollmentETLReset(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentApiFp(configuration).enrollmentEnrollmentETLReset(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentExportEmployers(version: string, options?: any): AxiosPromise<any> {
            return EnrollmentApiFp(configuration).enrollmentExportEmployers(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentPrepareEnrollmentsForEtlReset(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentApiFp(configuration).enrollmentPrepareEnrollmentsForEtlReset(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployerEnrollments(version: string, options?: any): AxiosPromise<PagedResultOfEmployerEnrollmentDto> {
            return EnrollmentApiFp(configuration).searchEmployerEnrollments(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentApi - object-oriented interface
 * @export
 * @class EnrollmentApi
 * @extends {BaseAPI}
 */
export class EnrollmentApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentEnrollmentETL(version: string, options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentEnrollmentETL(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentEnrollmentETLReset(version: string, options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentEnrollmentETLReset(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentExportEmployers(version: string, options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentExportEmployers(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentPrepareEnrollmentsForEtlReset(version: string, options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentPrepareEnrollmentsForEtlReset(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public searchEmployerEnrollments(version: string, options?: any) {
        return EnrollmentApiFp(this.configuration).searchEmployerEnrollments(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentDiscrepancyDetailApi - axios parameter creator
 * @export
 */
export const EnrollmentDiscrepancyDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentDiscrepancyDetail: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentDiscrepancyDetail.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/discrepancy/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentDiscrepancyDetail: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getEnrollmentDiscrepancyDetail.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/discrepancy`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentDiscrepancyDetailApi - functional programming interface
 * @export
 */
export const EnrollmentDiscrepancyDetailApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentDiscrepancyDetail(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EnrollmentDiscrepancyDetailApiAxiosParamCreator(configuration).exportEnrollmentDiscrepancyDetail(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrollmentDiscrepancyDetail(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfEnrollmentDiscrepancyDetailDto>> {
            const localVarAxiosArgs = await EnrollmentDiscrepancyDetailApiAxiosParamCreator(configuration).getEnrollmentDiscrepancyDetail(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentDiscrepancyDetailApi - factory interface
 * @export
 */
export const EnrollmentDiscrepancyDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentDiscrepancyDetail(version: string, options?: any): AxiosPromise<any> {
            return EnrollmentDiscrepancyDetailApiFp(configuration).exportEnrollmentDiscrepancyDetail(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentDiscrepancyDetail(version: string, options?: any): AxiosPromise<PagedResultOfEnrollmentDiscrepancyDetailDto> {
            return EnrollmentDiscrepancyDetailApiFp(configuration).getEnrollmentDiscrepancyDetail(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentDiscrepancyDetailApi - object-oriented interface
 * @export
 * @class EnrollmentDiscrepancyDetailApi
 * @extends {BaseAPI}
 */
export class EnrollmentDiscrepancyDetailApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentDiscrepancyDetailApi
     */
    public exportEnrollmentDiscrepancyDetail(version: string, options?: any) {
        return EnrollmentDiscrepancyDetailApiFp(this.configuration).exportEnrollmentDiscrepancyDetail(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentDiscrepancyDetailApi
     */
    public getEnrollmentDiscrepancyDetail(version: string, options?: any) {
        return EnrollmentDiscrepancyDetailApiFp(this.configuration).getEnrollmentDiscrepancyDetail(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileApi - axios parameter creator
 * @export
 */
export const EnrollmentFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EnrollmentFileSaveCommand} enrollmentFileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilePost: async (version: string, enrollmentFileSaveCommand: EnrollmentFileSaveCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilePost.');
            }
            // verify required parameter 'enrollmentFileSaveCommand' is not null or undefined
            if (enrollmentFileSaveCommand === null || enrollmentFileSaveCommand === undefined) {
                throw new RequiredError('enrollmentFileSaveCommand','Required parameter enrollmentFileSaveCommand was null or undefined when calling enrollmentFilePost.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/enrollmentFile`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof enrollmentFileSaveCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(enrollmentFileSaveCommand !== undefined ? enrollmentFileSaveCommand : {}) : (enrollmentFileSaveCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFile: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling exportEnrollmentFile.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/export/xlsx`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFileErrorDetails: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling exportEnrollmentFileErrorDetails.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentFileErrorDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/details/export/csv`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateType 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFileTemplate: async (templateType: number, fileExtension: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            if (templateType === null || templateType === undefined) {
                throw new RequiredError('templateType','Required parameter templateType was null or undefined when calling exportEnrollmentFileTemplate.');
            }
            // verify required parameter 'fileExtension' is not null or undefined
            if (fileExtension === null || fileExtension === undefined) {
                throw new RequiredError('fileExtension','Required parameter fileExtension was null or undefined when calling exportEnrollmentFileTemplate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentFileTemplate.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/templates/{templateType}/export/{fileExtension}`
                .replace(`{${"templateType"}}`, encodeURIComponent(String(templateType)))
                .replace(`{${"fileExtension"}}`, encodeURIComponent(String(fileExtension)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileApi - functional programming interface
 * @export
 */
export const EnrollmentFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EnrollmentFileSaveCommand} enrollmentFileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilePost(version: string, enrollmentFileSaveCommand: EnrollmentFileSaveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentFilesDetailDto>> {
            const localVarAxiosArgs = await EnrollmentFileApiAxiosParamCreator(configuration).enrollmentFilePost(version, enrollmentFileSaveCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentFile(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EnrollmentFileApiAxiosParamCreator(configuration).exportEnrollmentFile(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentFileErrorDetails(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EnrollmentFileApiAxiosParamCreator(configuration).exportEnrollmentFileErrorDetails(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} templateType 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentFileTemplate(templateType: number, fileExtension: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await EnrollmentFileApiAxiosParamCreator(configuration).exportEnrollmentFileTemplate(templateType, fileExtension, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileApi - factory interface
 * @export
 */
export const EnrollmentFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {EnrollmentFileSaveCommand} enrollmentFileSaveCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilePost(version: string, enrollmentFileSaveCommand: EnrollmentFileSaveCommand, options?: any): AxiosPromise<EnrollmentFilesDetailDto> {
            return EnrollmentFileApiFp(configuration).enrollmentFilePost(version, enrollmentFileSaveCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFile(fileId: string, version: string, options?: any): AxiosPromise<any> {
            return EnrollmentFileApiFp(configuration).exportEnrollmentFile(fileId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFileErrorDetails(fileId: string, version: string, options?: any): AxiosPromise<any> {
            return EnrollmentFileApiFp(configuration).exportEnrollmentFileErrorDetails(fileId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateType 
         * @param {string} fileExtension 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFileTemplate(templateType: number, fileExtension: string, version: string, options?: any): AxiosPromise<any> {
            return EnrollmentFileApiFp(configuration).exportEnrollmentFileTemplate(templateType, fileExtension, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileApi - object-oriented interface
 * @export
 * @class EnrollmentFileApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {EnrollmentFileSaveCommand} enrollmentFileSaveCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileApi
     */
    public enrollmentFilePost(version: string, enrollmentFileSaveCommand: EnrollmentFileSaveCommand, options?: any) {
        return EnrollmentFileApiFp(this.configuration).enrollmentFilePost(version, enrollmentFileSaveCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileApi
     */
    public exportEnrollmentFile(fileId: string, version: string, options?: any) {
        return EnrollmentFileApiFp(this.configuration).exportEnrollmentFile(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileApi
     */
    public exportEnrollmentFileErrorDetails(fileId: string, version: string, options?: any) {
        return EnrollmentFileApiFp(this.configuration).exportEnrollmentFileErrorDetails(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateType 
     * @param {string} fileExtension 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileApi
     */
    public exportEnrollmentFileTemplate(templateType: number, fileExtension: string, version: string, options?: any) {
        return EnrollmentFileApiFp(this.configuration).exportEnrollmentFileTemplate(templateType, fileExtension, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileAuditApi - axios parameter creator
 * @export
 */
export const EnrollmentFileAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileAuditGet: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling enrollmentFileAuditGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileAuditGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/auditdetail`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileAuditApi - functional programming interface
 * @export
 */
export const EnrollmentFileAuditApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileAuditGet(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentFileAuditDetailDto>> {
            const localVarAxiosArgs = await EnrollmentFileAuditApiAxiosParamCreator(configuration).enrollmentFileAuditGet(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileAuditApi - factory interface
 * @export
 */
export const EnrollmentFileAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileAuditGet(fileId: string, version: string, options?: any): AxiosPromise<EnrollmentFileAuditDetailDto> {
            return EnrollmentFileAuditApiFp(configuration).enrollmentFileAuditGet(fileId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileAuditApi - object-oriented interface
 * @export
 * @class EnrollmentFileAuditApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileAuditApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileAuditApi
     */
    public enrollmentFileAuditGet(fileId: string, version: string, options?: any) {
        return EnrollmentFileAuditApiFp(this.configuration).enrollmentFileAuditGet(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileExportApi - axios parameter creator
 * @export
 */
export const EnrollmentFileExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileExportExportEnrollmentFiles: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileExportExportEnrollmentFiles.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/ExportEnrollmentFiles`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileExportApi - functional programming interface
 * @export
 */
export const EnrollmentFileExportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileExportExportEnrollmentFiles(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFileExportApiAxiosParamCreator(configuration).enrollmentFileExportExportEnrollmentFiles(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileExportApi - factory interface
 * @export
 */
export const EnrollmentFileExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileExportExportEnrollmentFiles(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFileExportApiFp(configuration).enrollmentFileExportExportEnrollmentFiles(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileExportApi - object-oriented interface
 * @export
 * @class EnrollmentFileExportApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileExportApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileExportApi
     */
    public enrollmentFileExportExportEnrollmentFiles(version: string, options?: any) {
        return EnrollmentFileExportApiFp(this.configuration).enrollmentFileExportExportEnrollmentFiles(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileInitiateAuditApi - axios parameter creator
 * @export
 */
export const EnrollmentFileInitiateAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileInitiateAuditPost: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling enrollmentFileInitiateAuditPost.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileInitiateAuditPost.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/audit`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileInitiateAuditApi - functional programming interface
 * @export
 */
export const EnrollmentFileInitiateAuditApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileInitiateAuditPost(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFileInitiateAuditApiAxiosParamCreator(configuration).enrollmentFileInitiateAuditPost(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileInitiateAuditApi - factory interface
 * @export
 */
export const EnrollmentFileInitiateAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileInitiateAuditPost(fileId: string, version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFileInitiateAuditApiFp(configuration).enrollmentFileInitiateAuditPost(fileId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileInitiateAuditApi - object-oriented interface
 * @export
 * @class EnrollmentFileInitiateAuditApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileInitiateAuditApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileInitiateAuditApi
     */
    public enrollmentFileInitiateAuditPost(fileId: string, version: string, options?: any) {
        return EnrollmentFileInitiateAuditApiFp(this.configuration).enrollmentFileInitiateAuditPost(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileRecordValidationApi - axios parameter creator
 * @export
 */
export const EnrollmentFileRecordValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentRecordValidation: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling enrollmentRecordValidation.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentRecordValidation.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/recordValidation`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileRecordValidationApi - functional programming interface
 * @export
 */
export const EnrollmentFileRecordValidationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentRecordValidation(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentFileRecordValidationDto>> {
            const localVarAxiosArgs = await EnrollmentFileRecordValidationApiAxiosParamCreator(configuration).enrollmentRecordValidation(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileRecordValidationApi - factory interface
 * @export
 */
export const EnrollmentFileRecordValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentRecordValidation(fileId: string, version: string, options?: any): AxiosPromise<EnrollmentFileRecordValidationDto> {
            return EnrollmentFileRecordValidationApiFp(configuration).enrollmentRecordValidation(fileId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileRecordValidationApi - object-oriented interface
 * @export
 * @class EnrollmentFileRecordValidationApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileRecordValidationApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileRecordValidationApi
     */
    public enrollmentRecordValidation(fileId: string, version: string, options?: any) {
        return EnrollmentFileRecordValidationApiFp(this.configuration).enrollmentRecordValidation(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFileStatusApi - axios parameter creator
 * @export
 */
export const EnrollmentFileStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusCancelEnrollment: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileStatusCancelEnrollment.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/cancelStatus`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusPost: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileStatusPost.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/updateStatus`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusStartProcessing: async (version: string, fileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFileStatusStartProcessing.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/startProcessing`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFileStatusApi - functional programming interface
 * @export
 */
export const EnrollmentFileStatusApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileStatusCancelEnrollment(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFileStatusApiAxiosParamCreator(configuration).enrollmentFileStatusCancelEnrollment(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileStatusPost(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFileStatusApiAxiosParamCreator(configuration).enrollmentFileStatusPost(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFileStatusStartProcessing(version: string, fileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFileStatusApiAxiosParamCreator(configuration).enrollmentFileStatusStartProcessing(version, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFileStatusApi - factory interface
 * @export
 */
export const EnrollmentFileStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusCancelEnrollment(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFileStatusApiFp(configuration).enrollmentFileStatusCancelEnrollment(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusPost(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFileStatusApiFp(configuration).enrollmentFileStatusPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFileStatusStartProcessing(version: string, fileId?: string, options?: any): AxiosPromise<void> {
            return EnrollmentFileStatusApiFp(configuration).enrollmentFileStatusStartProcessing(version, fileId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFileStatusApi - object-oriented interface
 * @export
 * @class EnrollmentFileStatusApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileStatusApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileStatusApi
     */
    public enrollmentFileStatusCancelEnrollment(version: string, options?: any) {
        return EnrollmentFileStatusApiFp(this.configuration).enrollmentFileStatusCancelEnrollment(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileStatusApi
     */
    public enrollmentFileStatusPost(version: string, options?: any) {
        return EnrollmentFileStatusApiFp(this.configuration).enrollmentFileStatusPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFileStatusApi
     */
    public enrollmentFileStatusStartProcessing(version: string, fileId?: string, options?: any) {
        return EnrollmentFileStatusApiFp(this.configuration).enrollmentFileStatusStartProcessing(version, fileId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFilesApi - axios parameter creator
 * @export
 */
export const EnrollmentFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesEnrollmentFileETL: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesEnrollmentFileETL.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesEnrollmentFileETLReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesEnrollmentFileETLReset.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {FileSystemNotificationDto} fileSystemNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesFileSystemNotification: async (version: string, fileSystemNotificationDto: FileSystemNotificationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesFileSystemNotification.');
            }
            // verify required parameter 'fileSystemNotificationDto' is not null or undefined
            if (fileSystemNotificationDto === null || fileSystemNotificationDto === undefined) {
                throw new RequiredError('fileSystemNotificationDto','Required parameter fileSystemNotificationDto was null or undefined when calling enrollmentFilesFileSystemNotification.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileSystemNotification`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fileSystemNotificationDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fileSystemNotificationDto !== undefined ? fileSystemNotificationDto : {}) : (fileSystemNotificationDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesPrepareEnrollmentFilesForEtlReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesPrepareEnrollmentFilesForEtlReset.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/etl/setup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFilesApi - functional programming interface
 * @export
 */
export const EnrollmentFilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesEnrollmentFileETL(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFilesApiAxiosParamCreator(configuration).enrollmentFilesEnrollmentFileETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesEnrollmentFileETLReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFilesApiAxiosParamCreator(configuration).enrollmentFilesEnrollmentFileETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {FileSystemNotificationDto} fileSystemNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesFileSystemNotification(version: string, fileSystemNotificationDto: FileSystemNotificationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFilesApiAxiosParamCreator(configuration).enrollmentFilesFileSystemNotification(version, fileSystemNotificationDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesPrepareEnrollmentFilesForEtlReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EnrollmentFilesApiAxiosParamCreator(configuration).enrollmentFilesPrepareEnrollmentFilesForEtlReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFilesApi - factory interface
 * @export
 */
export const EnrollmentFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesEnrollmentFileETL(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFilesApiFp(configuration).enrollmentFilesEnrollmentFileETL(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesEnrollmentFileETLReset(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFilesApiFp(configuration).enrollmentFilesEnrollmentFileETLReset(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {FileSystemNotificationDto} fileSystemNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesFileSystemNotification(version: string, fileSystemNotificationDto: FileSystemNotificationDto, options?: any): AxiosPromise<void> {
            return EnrollmentFilesApiFp(configuration).enrollmentFilesFileSystemNotification(version, fileSystemNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesPrepareEnrollmentFilesForEtlReset(version: string, options?: any): AxiosPromise<void> {
            return EnrollmentFilesApiFp(configuration).enrollmentFilesPrepareEnrollmentFilesForEtlReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFilesApi - object-oriented interface
 * @export
 * @class EnrollmentFilesApi
 * @extends {BaseAPI}
 */
export class EnrollmentFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesApi
     */
    public enrollmentFilesEnrollmentFileETL(version: string, options?: any) {
        return EnrollmentFilesApiFp(this.configuration).enrollmentFilesEnrollmentFileETL(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesApi
     */
    public enrollmentFilesEnrollmentFileETLReset(version: string, options?: any) {
        return EnrollmentFilesApiFp(this.configuration).enrollmentFilesEnrollmentFileETLReset(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {FileSystemNotificationDto} fileSystemNotificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesApi
     */
    public enrollmentFilesFileSystemNotification(version: string, fileSystemNotificationDto: FileSystemNotificationDto, options?: any) {
        return EnrollmentFilesApiFp(this.configuration).enrollmentFilesFileSystemNotification(version, fileSystemNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesApi
     */
    public enrollmentFilesPrepareEnrollmentFilesForEtlReset(version: string, options?: any) {
        return EnrollmentFilesApiFp(this.configuration).enrollmentFilesPrepareEnrollmentFilesForEtlReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentFilesHistoryApi - axios parameter creator
 * @export
 */
export const EnrollmentFilesHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesHistoryGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetDetails: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling enrollmentFilesHistoryGetDetails.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesHistoryGetDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{id}/Details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetEnrollmentFileApplications: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesHistoryGetEnrollmentFileApplications.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/applications`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetEnrollmentFileErrorDetails: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentFilesHistoryGetEnrollmentFileErrorDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/Error/Details`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentFilesHistoryApi - functional programming interface
 * @export
 */
export const EnrollmentFilesHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesHistoryGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfEnrollmentFilesDetailDto>> {
            const localVarAxiosArgs = await EnrollmentFilesHistoryApiAxiosParamCreator(configuration).enrollmentFilesHistoryGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesHistoryGetDetails(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrollmentFilesDetailDto>>> {
            const localVarAxiosArgs = await EnrollmentFilesHistoryApiAxiosParamCreator(configuration).enrollmentFilesHistoryGetDetails(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesHistoryGetEnrollmentFileApplications(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationDto>>> {
            const localVarAxiosArgs = await EnrollmentFilesHistoryApiAxiosParamCreator(configuration).enrollmentFilesHistoryGetEnrollmentFileApplications(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeErrorDetailsDto>>> {
            const localVarAxiosArgs = await EnrollmentFilesHistoryApiAxiosParamCreator(configuration).enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentFilesHistoryApi - factory interface
 * @export
 */
export const EnrollmentFilesHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGet(version: string, options?: any): AxiosPromise<PagedResultOfEnrollmentFilesDetailDto> {
            return EnrollmentFilesHistoryApiFp(configuration).enrollmentFilesHistoryGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetDetails(id: string, version: string, options?: any): AxiosPromise<Array<EnrollmentFilesDetailDto>> {
            return EnrollmentFilesHistoryApiFp(configuration).enrollmentFilesHistoryGetDetails(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetEnrollmentFileApplications(version: string, options?: any): AxiosPromise<Array<ApplicationDto>> {
            return EnrollmentFilesHistoryApiFp(configuration).enrollmentFilesHistoryGetEnrollmentFileApplications(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version: string, options?: any): AxiosPromise<Array<EmployeeErrorDetailsDto>> {
            return EnrollmentFilesHistoryApiFp(configuration).enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentFilesHistoryApi - object-oriented interface
 * @export
 * @class EnrollmentFilesHistoryApi
 * @extends {BaseAPI}
 */
export class EnrollmentFilesHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesHistoryApi
     */
    public enrollmentFilesHistoryGet(version: string, options?: any) {
        return EnrollmentFilesHistoryApiFp(this.configuration).enrollmentFilesHistoryGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesHistoryApi
     */
    public enrollmentFilesHistoryGetDetails(id: string, version: string, options?: any) {
        return EnrollmentFilesHistoryApiFp(this.configuration).enrollmentFilesHistoryGetDetails(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesHistoryApi
     */
    public enrollmentFilesHistoryGetEnrollmentFileApplications(version: string, options?: any) {
        return EnrollmentFilesHistoryApiFp(this.configuration).enrollmentFilesHistoryGetEnrollmentFileApplications(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentFilesHistoryApi
     */
    public enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version: string, options?: any) {
        return EnrollmentFilesHistoryApiFp(this.configuration).enrollmentFilesHistoryGetEnrollmentFileErrorDetails(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollmentStatusApi - axios parameter creator
 * @export
 */
export const EnrollmentStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentStatusGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentStatusGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/enrollmentStatus`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentStatusApi - functional programming interface
 * @export
 */
export const EnrollmentStatusApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentStatusGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrollmentStatusDto>>> {
            const localVarAxiosArgs = await EnrollmentStatusApiAxiosParamCreator(configuration).enrollmentStatusGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentStatusApi - factory interface
 * @export
 */
export const EnrollmentStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentStatusGet(version: string, options?: any): AxiosPromise<Array<EnrollmentStatusDto>> {
            return EnrollmentStatusApiFp(configuration).enrollmentStatusGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentStatusApi - object-oriented interface
 * @export
 * @class EnrollmentStatusApi
 * @extends {BaseAPI}
 */
export class EnrollmentStatusApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentStatusApi
     */
    public enrollmentStatusGet(version: string, options?: any) {
        return EnrollmentStatusApiFp(this.configuration).enrollmentStatusGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExternalUploadQueueApi - axios parameter creator
 * @export
 */
export const ExternalUploadQueueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueExportExternalUploadFile: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUploadQueueExportExternalUploadFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/externalUploadQueue/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUploadQueueGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/externalUploadQueue`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalUploadQueueApi - functional programming interface
 * @export
 */
export const ExternalUploadQueueApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUploadQueueExportExternalUploadFile(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExternalUploadQueueApiAxiosParamCreator(configuration).externalUploadQueueExportExternalUploadFile(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUploadQueueGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedExternalUploadQueue>> {
            const localVarAxiosArgs = await ExternalUploadQueueApiAxiosParamCreator(configuration).externalUploadQueueGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalUploadQueueApi - factory interface
 * @export
 */
export const ExternalUploadQueueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueExportExternalUploadFile(version: string, options?: any): AxiosPromise<any> {
            return ExternalUploadQueueApiFp(configuration).externalUploadQueueExportExternalUploadFile(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueGet(version: string, options?: any): AxiosPromise<PagedExternalUploadQueue> {
            return ExternalUploadQueueApiFp(configuration).externalUploadQueueGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalUploadQueueApi - object-oriented interface
 * @export
 * @class ExternalUploadQueueApi
 * @extends {BaseAPI}
 */
export class ExternalUploadQueueApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUploadQueueApi
     */
    public externalUploadQueueExportExternalUploadFile(version: string, options?: any) {
        return ExternalUploadQueueApiFp(this.configuration).externalUploadQueueExportExternalUploadFile(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUploadQueueApi
     */
    public externalUploadQueueGet(version: string, options?: any) {
        return ExternalUploadQueueApiFp(this.configuration).externalUploadQueueGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExternalUploadQueueDetailsApi - axios parameter creator
 * @export
 */
export const ExternalUploadQueueDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueDetailsExportExternalUploadFile: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling externalUploadQueueDetailsExportExternalUploadFile.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUploadQueueDetailsExportExternalUploadFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/externalUploadQueueDetails/csv`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueDetailsGet: async (fileId: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling externalUploadQueueDetailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUploadQueueDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/{fileId}/externalUploadQueueDetails`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalUploadQueueDetailsApi - functional programming interface
 * @export
 */
export const ExternalUploadQueueDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUploadQueueDetailsExportExternalUploadFile(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExternalUploadQueueDetailsApiAxiosParamCreator(configuration).externalUploadQueueDetailsExportExternalUploadFile(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUploadQueueDetailsGet(fileId: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedExternalUploadQueueDetails>> {
            const localVarAxiosArgs = await ExternalUploadQueueDetailsApiAxiosParamCreator(configuration).externalUploadQueueDetailsGet(fileId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalUploadQueueDetailsApi - factory interface
 * @export
 */
export const ExternalUploadQueueDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueDetailsExportExternalUploadFile(fileId: string, version: string, options?: any): AxiosPromise<any> {
            return ExternalUploadQueueDetailsApiFp(configuration).externalUploadQueueDetailsExportExternalUploadFile(fileId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUploadQueueDetailsGet(fileId: string, version: string, options?: any): AxiosPromise<PagedExternalUploadQueueDetails> {
            return ExternalUploadQueueDetailsApiFp(configuration).externalUploadQueueDetailsGet(fileId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalUploadQueueDetailsApi - object-oriented interface
 * @export
 * @class ExternalUploadQueueDetailsApi
 * @extends {BaseAPI}
 */
export class ExternalUploadQueueDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUploadQueueDetailsApi
     */
    public externalUploadQueueDetailsExportExternalUploadFile(fileId: string, version: string, options?: any) {
        return ExternalUploadQueueDetailsApiFp(this.configuration).externalUploadQueueDetailsExportExternalUploadFile(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUploadQueueDetailsApi
     */
    public externalUploadQueueDetailsGet(fileId: string, version: string, options?: any) {
        return ExternalUploadQueueDetailsApiFp(this.configuration).externalUploadQueueDetailsGet(fileId, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileFeedbackApi - axios parameter creator
 * @export
 */
export const FileFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileFeedbackGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileFeedbackGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileFeedback/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileFeedbackApi - functional programming interface
 * @export
 */
export const FileFeedbackApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileFeedbackGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileFeedbackMetricsDto>> {
            const localVarAxiosArgs = await FileFeedbackApiAxiosParamCreator(configuration).fileFeedbackGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileFeedbackApi - factory interface
 * @export
 */
export const FileFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileFeedbackGet(version: string, options?: any): AxiosPromise<FileFeedbackMetricsDto> {
            return FileFeedbackApiFp(configuration).fileFeedbackGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileFeedbackApi - object-oriented interface
 * @export
 * @class FileFeedbackApi
 * @extends {BaseAPI}
 */
export class FileFeedbackApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileFeedbackApi
     */
    public fileFeedbackGet(version: string, options?: any) {
        return FileFeedbackApiFp(this.configuration).fileFeedbackGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileProfileApi - axios parameter creator
 * @export
 */
export const FileProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfileFileProfileETL: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileProfileFileProfileETL.');
            }
            const localVarPath = `/api/v{version}/fileProfile/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfileGetRejectFileProfileByFileName: async (fileName: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling fileProfileGetRejectFileProfileByFileName.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileProfileGetRejectFileProfileByFileName.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{fileName}/fileProfile`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfilePrepareFileProfileReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileProfilePrepareFileProfileReset.');
            }
            const localVarPath = `/api/v{version}/fileProfile/etl/setup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileProfileApi - functional programming interface
 * @export
 */
export const FileProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileProfileFileProfileETL(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileProfileApiAxiosParamCreator(configuration).fileProfileFileProfileETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileProfileGetRejectFileProfileByFileName(fileName: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RejectFileProfileDto>> {
            const localVarAxiosArgs = await FileProfileApiAxiosParamCreator(configuration).fileProfileGetRejectFileProfileByFileName(fileName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileProfilePrepareFileProfileReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileProfileApiAxiosParamCreator(configuration).fileProfilePrepareFileProfileReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileProfileApi - factory interface
 * @export
 */
export const FileProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfileFileProfileETL(version: string, options?: any): AxiosPromise<void> {
            return FileProfileApiFp(configuration).fileProfileFileProfileETL(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfileGetRejectFileProfileByFileName(fileName: string, version: string, options?: any): AxiosPromise<RejectFileProfileDto> {
            return FileProfileApiFp(configuration).fileProfileGetRejectFileProfileByFileName(fileName, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProfilePrepareFileProfileReset(version: string, options?: any): AxiosPromise<void> {
            return FileProfileApiFp(configuration).fileProfilePrepareFileProfileReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileProfileApi - object-oriented interface
 * @export
 * @class FileProfileApi
 * @extends {BaseAPI}
 */
export class FileProfileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProfileApi
     */
    public fileProfileFileProfileETL(version: string, options?: any) {
        return FileProfileApiFp(this.configuration).fileProfileFileProfileETL(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProfileApi
     */
    public fileProfileGetRejectFileProfileByFileName(fileName: string, version: string, options?: any) {
        return FileProfileApiFp(this.configuration).fileProfileGetRejectFileProfileByFileName(fileName, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProfileApi
     */
    public fileProfilePrepareFileProfileReset(version: string, options?: any) {
        return FileProfileApiFp(this.configuration).fileProfilePrepareFileProfileReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileSystemNotificationSyncApi - axios parameter creator
 * @export
 */
export const FileSystemNotificationSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileSystemNotificationSyncFileSystemNotificationSync: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileSystemNotificationSyncFileSystemNotificationSync.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileSystemNotificationSync`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileSystemNotificationSyncApi - functional programming interface
 * @export
 */
export const FileSystemNotificationSyncApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileSystemNotificationSyncFileSystemNotificationSync(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileSystemNotificationSyncApiAxiosParamCreator(configuration).fileSystemNotificationSyncFileSystemNotificationSync(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileSystemNotificationSyncApi - factory interface
 * @export
 */
export const FileSystemNotificationSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileSystemNotificationSyncFileSystemNotificationSync(version: string, options?: any): AxiosPromise<void> {
            return FileSystemNotificationSyncApiFp(configuration).fileSystemNotificationSyncFileSystemNotificationSync(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileSystemNotificationSyncApi - object-oriented interface
 * @export
 * @class FileSystemNotificationSyncApi
 * @extends {BaseAPI}
 */
export class FileSystemNotificationSyncApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileSystemNotificationSyncApi
     */
    public fileSystemNotificationSyncFileSystemNotificationSync(version: string, options?: any) {
        return FileSystemNotificationSyncApiFp(this.configuration).fileSystemNotificationSyncFileSystemNotificationSync(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileTrackingMonitorApi - axios parameter creator
 * @export
 */
export const FileTrackingMonitorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileTrackingMonitorGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileTrackingMonitorGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileTrackingMonitor/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileTrackingMonitorApi - functional programming interface
 * @export
 */
export const FileTrackingMonitorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileTrackingMonitorGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTrackingMonitorMetricsDto>> {
            const localVarAxiosArgs = await FileTrackingMonitorApiAxiosParamCreator(configuration).fileTrackingMonitorGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileTrackingMonitorApi - factory interface
 * @export
 */
export const FileTrackingMonitorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileTrackingMonitorGet(version: string, options?: any): AxiosPromise<FileTrackingMonitorMetricsDto> {
            return FileTrackingMonitorApiFp(configuration).fileTrackingMonitorGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileTrackingMonitorApi - object-oriented interface
 * @export
 * @class FileTrackingMonitorApi
 * @extends {BaseAPI}
 */
export class FileTrackingMonitorApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileTrackingMonitorApi
     */
    public fileTrackingMonitorGet(version: string, options?: any) {
        return FileTrackingMonitorApiFp(this.configuration).fileTrackingMonitorGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileVolumeTurnAroundTimeChartApi - axios parameter creator
 * @export
 */
export const FileVolumeTurnAroundTimeChartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileVolumeTurnAroundTimeChartGet: async (version: string, chartType?: string, employerName?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileVolumeTurnAroundTimeChartGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/esrCharts/lifeCycleReport/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (chartType !== undefined) {
                localVarQueryParameter['chartType'] = chartType;
            }

            if (employerName !== undefined) {
                localVarQueryParameter['employerName'] = employerName;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileVolumeTurnAroundTimeChartGet2: async (version: string, chartType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileVolumeTurnAroundTimeChartGet2.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/lifeCycleReport/esr/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (chartType !== undefined) {
                localVarQueryParameter['chartType'] = chartType;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileVolumeTurnAroundTimeChartApi - functional programming interface
 * @export
 */
export const FileVolumeTurnAroundTimeChartApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileVolumeTurnAroundTimeChartGet(version: string, chartType?: string, employerName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LifeCycleReportChartDetailsDto>> {
            const localVarAxiosArgs = await FileVolumeTurnAroundTimeChartApiAxiosParamCreator(configuration).fileVolumeTurnAroundTimeChartGet(version, chartType, employerName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileVolumeTurnAroundTimeChartGet2(version: string, chartType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LifeCycleReportChartDetailsDto>> {
            const localVarAxiosArgs = await FileVolumeTurnAroundTimeChartApiAxiosParamCreator(configuration).fileVolumeTurnAroundTimeChartGet2(version, chartType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileVolumeTurnAroundTimeChartApi - factory interface
 * @export
 */
export const FileVolumeTurnAroundTimeChartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileVolumeTurnAroundTimeChartGet(version: string, chartType?: string, employerName?: string, options?: any): AxiosPromise<LifeCycleReportChartDetailsDto> {
            return FileVolumeTurnAroundTimeChartApiFp(configuration).fileVolumeTurnAroundTimeChartGet(version, chartType, employerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} [chartType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileVolumeTurnAroundTimeChartGet2(version: string, chartType?: string, options?: any): AxiosPromise<LifeCycleReportChartDetailsDto> {
            return FileVolumeTurnAroundTimeChartApiFp(configuration).fileVolumeTurnAroundTimeChartGet2(version, chartType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileVolumeTurnAroundTimeChartApi - object-oriented interface
 * @export
 * @class FileVolumeTurnAroundTimeChartApi
 * @extends {BaseAPI}
 */
export class FileVolumeTurnAroundTimeChartApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [chartType] 
     * @param {string} [employerName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileVolumeTurnAroundTimeChartApi
     */
    public fileVolumeTurnAroundTimeChartGet(version: string, chartType?: string, employerName?: string, options?: any) {
        return FileVolumeTurnAroundTimeChartApiFp(this.configuration).fileVolumeTurnAroundTimeChartGet(version, chartType, employerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} [chartType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileVolumeTurnAroundTimeChartApi
     */
    public fileVolumeTurnAroundTimeChartGet2(version: string, chartType?: string, options?: any) {
        return FileVolumeTurnAroundTimeChartApiFp(this.configuration).fileVolumeTurnAroundTimeChartGet2(version, chartType, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FilesNotProcessedApi - axios parameter creator
 * @export
 */
export const FilesNotProcessedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesNotProcessedGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling filesNotProcessedGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/filesNotProcessed/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesNotProcessedApi - functional programming interface
 * @export
 */
export const FilesNotProcessedApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesNotProcessedGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilesNotProcessedMetricsDto>> {
            const localVarAxiosArgs = await FilesNotProcessedApiAxiosParamCreator(configuration).filesNotProcessedGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FilesNotProcessedApi - factory interface
 * @export
 */
export const FilesNotProcessedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesNotProcessedGet(version: string, options?: any): AxiosPromise<FilesNotProcessedMetricsDto> {
            return FilesNotProcessedApiFp(configuration).filesNotProcessedGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesNotProcessedApi - object-oriented interface
 * @export
 * @class FilesNotProcessedApi
 * @extends {BaseAPI}
 */
export class FilesNotProcessedApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesNotProcessedApi
     */
    public filesNotProcessedGet(version: string, options?: any) {
        return FilesNotProcessedApiFp(this.configuration).filesNotProcessedGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * GenelcoBatchFileApi - axios parameter creator
 * @export
 */
export const GenelcoBatchFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileExportBatchFile: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling genelcoBatchFileExportBatchFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling genelcoBatchFileGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/getBatchFile`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileReAuditBatchFile: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling genelcoBatchFileReAuditBatchFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/reAuditBatchFile`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileReGenerateBatchFile: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling genelcoBatchFileReGenerateBatchFile.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/reGenerateBatchFile`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GenelcoBatchFileApi - functional programming interface
 * @export
 */
export const GenelcoBatchFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genelcoBatchFileExportBatchFile(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await GenelcoBatchFileApiAxiosParamCreator(configuration).genelcoBatchFileExportBatchFile(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genelcoBatchFileGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfGenelcoBatchFileDto>> {
            const localVarAxiosArgs = await GenelcoBatchFileApiAxiosParamCreator(configuration).genelcoBatchFileGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genelcoBatchFileReAuditBatchFile(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GenelcoBatchFileApiAxiosParamCreator(configuration).genelcoBatchFileReAuditBatchFile(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genelcoBatchFileReGenerateBatchFile(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GenelcoBatchFileApiAxiosParamCreator(configuration).genelcoBatchFileReGenerateBatchFile(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GenelcoBatchFileApi - factory interface
 * @export
 */
export const GenelcoBatchFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileExportBatchFile(version: string, options?: any): AxiosPromise<any> {
            return GenelcoBatchFileApiFp(configuration).genelcoBatchFileExportBatchFile(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileGet(version: string, options?: any): AxiosPromise<PagedResultOfGenelcoBatchFileDto> {
            return GenelcoBatchFileApiFp(configuration).genelcoBatchFileGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileReAuditBatchFile(version: string, options?: any): AxiosPromise<void> {
            return GenelcoBatchFileApiFp(configuration).genelcoBatchFileReAuditBatchFile(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genelcoBatchFileReGenerateBatchFile(version: string, options?: any): AxiosPromise<void> {
            return GenelcoBatchFileApiFp(configuration).genelcoBatchFileReGenerateBatchFile(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GenelcoBatchFileApi - object-oriented interface
 * @export
 * @class GenelcoBatchFileApi
 * @extends {BaseAPI}
 */
export class GenelcoBatchFileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenelcoBatchFileApi
     */
    public genelcoBatchFileExportBatchFile(version: string, options?: any) {
        return GenelcoBatchFileApiFp(this.configuration).genelcoBatchFileExportBatchFile(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenelcoBatchFileApi
     */
    public genelcoBatchFileGet(version: string, options?: any) {
        return GenelcoBatchFileApiFp(this.configuration).genelcoBatchFileGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenelcoBatchFileApi
     */
    public genelcoBatchFileReAuditBatchFile(version: string, options?: any) {
        return GenelcoBatchFileApiFp(this.configuration).genelcoBatchFileReAuditBatchFile(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenelcoBatchFileApi
     */
    public genelcoBatchFileReGenerateBatchFile(version: string, options?: any) {
        return GenelcoBatchFileApiFp(this.configuration).genelcoBatchFileReGenerateBatchFile(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * GroupWebComparisionApi - axios parameter creator
 * @export
 */
export const GroupWebComparisionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupWebComparisionGroupWebComparision: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling groupWebComparisionGroupWebComparision.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/CompareGroupWeb`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupWebComparisionApi - functional programming interface
 * @export
 */
export const GroupWebComparisionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupWebComparisionGroupWebComparision(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GroupWebComparisionApiAxiosParamCreator(configuration).groupWebComparisionGroupWebComparision(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GroupWebComparisionApi - factory interface
 * @export
 */
export const GroupWebComparisionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupWebComparisionGroupWebComparision(version: string, options?: any): AxiosPromise<void> {
            return GroupWebComparisionApiFp(configuration).groupWebComparisionGroupWebComparision(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupWebComparisionApi - object-oriented interface
 * @export
 * @class GroupWebComparisionApi
 * @extends {BaseAPI}
 */
export class GroupWebComparisionApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupWebComparisionApi
     */
    public groupWebComparisionGroupWebComparision(version: string, options?: any) {
        return GroupWebComparisionApiFp(this.configuration).groupWebComparisionGroupWebComparision(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async heartbeatGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HistoryApi - axios parameter creator
 * @export
 */
export const HistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyExportProcessingHistory: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyExportProcessingHistory.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyPost: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyPost.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryApi - functional programming interface
 * @export
 */
export const HistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyExportProcessingHistory(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await HistoryApiAxiosParamCreator(configuration).historyExportProcessingHistory(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedRejectHistory>> {
            const localVarAxiosArgs = await HistoryApiAxiosParamCreator(configuration).historyGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyPost(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await HistoryApiAxiosParamCreator(configuration).historyPost(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HistoryApi - factory interface
 * @export
 */
export const HistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyExportProcessingHistory(version: string, options?: any): AxiosPromise<any> {
            return HistoryApiFp(configuration).historyExportProcessingHistory(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyGet(version: string, options?: any): AxiosPromise<PagedRejectHistory> {
            return HistoryApiFp(configuration).historyGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyPost(version: string, options?: any): AxiosPromise<void> {
            return HistoryApiFp(configuration).historyPost(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
export class HistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public historyExportProcessingHistory(version: string, options?: any) {
        return HistoryApiFp(this.configuration).historyExportProcessingHistory(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public historyGet(version: string, options?: any) {
        return HistoryApiFp(this.configuration).historyGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public historyPost(version: string, options?: any) {
        return HistoryApiFp(this.configuration).historyPost(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HistoryDetailsApi - axios parameter creator
 * @export
 */
export const HistoryDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsExportProcessingHistoryDetails: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyDetailsExportProcessingHistoryDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/details/applications/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsGetEnrollmentFileRejectDetailsApplications: async (id: string, applicationSource: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsApplications.');
            }
            // verify required parameter 'applicationSource' is not null or undefined
            if (applicationSource === null || applicationSource === undefined) {
                throw new RequiredError('applicationSource','Required parameter applicationSource was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsApplications.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsApplications.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{id}/{applicationSource}/details/applications`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"applicationSource"}}`, encodeURIComponent(String(applicationSource)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId: async (id: string, applicationSource: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId.');
            }
            // verify required parameter 'applicationSource' is not null or undefined
            if (applicationSource === null || applicationSource === undefined) {
                throw new RequiredError('applicationSource','Required parameter applicationSource was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/rejects/{id}/{applicationSource}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"applicationSource"}}`, encodeURIComponent(String(applicationSource)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryDetailsApi - functional programming interface
 * @export
 */
export const HistoryDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyDetailsExportProcessingHistoryDetails(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await HistoryDetailsApiAxiosParamCreator(configuration).historyDetailsExportProcessingHistoryDetails(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyDetailsGetEnrollmentFileRejectDetailsApplications(id: string, applicationSource: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfRejectApplicationDto>> {
            const localVarAxiosArgs = await HistoryDetailsApiAxiosParamCreator(configuration).historyDetailsGetEnrollmentFileRejectDetailsApplications(id, applicationSource, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id: string, applicationSource: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfRejectHistoryDetailDto>> {
            const localVarAxiosArgs = await HistoryDetailsApiAxiosParamCreator(configuration).historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id, applicationSource, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HistoryDetailsApi - factory interface
 * @export
 */
export const HistoryDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsExportProcessingHistoryDetails(version: string, options?: any): AxiosPromise<any> {
            return HistoryDetailsApiFp(configuration).historyDetailsExportProcessingHistoryDetails(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsGetEnrollmentFileRejectDetailsApplications(id: string, applicationSource: string, version: string, options?: any): AxiosPromise<PagedResultOfRejectApplicationDto> {
            return HistoryDetailsApiFp(configuration).historyDetailsGetEnrollmentFileRejectDetailsApplications(id, applicationSource, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id: string, applicationSource: string, version: string, options?: any): AxiosPromise<PagedResultOfRejectHistoryDetailDto> {
            return HistoryDetailsApiFp(configuration).historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id, applicationSource, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryDetailsApi - object-oriented interface
 * @export
 * @class HistoryDetailsApi
 * @extends {BaseAPI}
 */
export class HistoryDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryDetailsApi
     */
    public historyDetailsExportProcessingHistoryDetails(version: string, options?: any) {
        return HistoryDetailsApiFp(this.configuration).historyDetailsExportProcessingHistoryDetails(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryDetailsApi
     */
    public historyDetailsGetEnrollmentFileRejectDetailsApplications(id: string, applicationSource: string, version: string, options?: any) {
        return HistoryDetailsApiFp(this.configuration).historyDetailsGetEnrollmentFileRejectDetailsApplications(id, applicationSource, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} fileId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryDetailsApi
     */
    public historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id: string, applicationSource: string, version: string, options?: any) {
        return HistoryDetailsApiFp(this.configuration).historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id, applicationSource, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notesGet: async (fileName: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling notesGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling notesGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/fileProfile/{fileName}/notes`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notesGet(fileName: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotesDto>>> {
            const localVarAxiosArgs = await NotesApiAxiosParamCreator(configuration).notesGet(fileName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notesGet(fileName: string, version: string, options?: any): AxiosPromise<Array<NotesDto>> {
            return NotesApiFp(configuration).notesGet(fileName, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
    /**
     * 
     * @param {string} fileName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public notesGet(fileName: string, version: string, options?: any) {
        return NotesApiFp(this.configuration).notesGet(fileName, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEtlStatuses(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>>> {
            const localVarAxiosArgs = await ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFilesDetails: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentFilesDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/esr/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/pending`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet2: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryGet2.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/metrics`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet22: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryGet22.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/esr`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet23: async (caseRequestId: number, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseRequestId' is not null or undefined
            if (caseRequestId === null || caseRequestId === undefined) {
                throw new RequiredError('caseRequestId','Required parameter caseRequestId was null or undefined when calling processingHistoryGet23.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryGet23.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/esr/{caseRequestId}/detail`
                .replace(`{${"caseRequestId"}}`, encodeURIComponent(String(caseRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryApi - functional programming interface
 * @export
 */
export const ProcessingHistoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentFilesDetails(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ProcessingHistoryApiAxiosParamCreator(configuration).exportEnrollmentFilesDetails(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPendingProcessingHistory>> {
            const localVarAxiosArgs = await ProcessingHistoryApiAxiosParamCreator(configuration).processingHistoryGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryGet2(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryMetricsDto>> {
            const localVarAxiosArgs = await ProcessingHistoryApiAxiosParamCreator(configuration).processingHistoryGet2(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryGet22(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedEsrProcessingHistory>> {
            const localVarAxiosArgs = await ProcessingHistoryApiAxiosParamCreator(configuration).processingHistoryGet22(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} caseRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryGet23(caseRequestId: number, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryEsrDto>> {
            const localVarAxiosArgs = await ProcessingHistoryApiAxiosParamCreator(configuration).processingHistoryGet23(caseRequestId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryApi - factory interface
 * @export
 */
export const ProcessingHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentFilesDetails(version: string, options?: any): AxiosPromise<any> {
            return ProcessingHistoryApiFp(configuration).exportEnrollmentFilesDetails(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet(version: string, options?: any): AxiosPromise<PagedPendingProcessingHistory> {
            return ProcessingHistoryApiFp(configuration).processingHistoryGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet2(version: string, options?: any): AxiosPromise<ProcessingHistoryMetricsDto> {
            return ProcessingHistoryApiFp(configuration).processingHistoryGet2(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet22(version: string, options?: any): AxiosPromise<PagedEsrProcessingHistory> {
            return ProcessingHistoryApiFp(configuration).processingHistoryGet22(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseRequestId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryGet23(caseRequestId: number, version: string, options?: any): AxiosPromise<ProcessingHistoryEsrDto> {
            return ProcessingHistoryApiFp(configuration).processingHistoryGet23(caseRequestId, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryApi - object-oriented interface
 * @export
 * @class ProcessingHistoryApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryApi
     */
    public exportEnrollmentFilesDetails(version: string, options?: any) {
        return ProcessingHistoryApiFp(this.configuration).exportEnrollmentFilesDetails(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryApi
     */
    public processingHistoryGet(version: string, options?: any) {
        return ProcessingHistoryApiFp(this.configuration).processingHistoryGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryApi
     */
    public processingHistoryGet2(version: string, options?: any) {
        return ProcessingHistoryApiFp(this.configuration).processingHistoryGet2(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryApi
     */
    public processingHistoryGet22(version: string, options?: any) {
        return ProcessingHistoryApiFp(this.configuration).processingHistoryGet22(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseRequestId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryApi
     */
    public processingHistoryGet23(caseRequestId: number, version: string, options?: any) {
        return ProcessingHistoryApiFp(this.configuration).processingHistoryGet23(caseRequestId, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryAppAWDDetailsApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryAppAWDDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppAWDDetailsGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling processingHistoryAppAWDDetailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryAppAWDDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/history/awd/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryAppAWDDetailsApi - functional programming interface
 * @export
 */
export const ProcessingHistoryAppAWDDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryAppAWDDetailsGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AWDProcessingHistoryDto>> {
            const localVarAxiosArgs = await ProcessingHistoryAppAWDDetailsApiAxiosParamCreator(configuration).processingHistoryAppAWDDetailsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryAppAWDDetailsApi - factory interface
 * @export
 */
export const ProcessingHistoryAppAWDDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppAWDDetailsGet(id: string, version: string, options?: any): AxiosPromise<AWDProcessingHistoryDto> {
            return ProcessingHistoryAppAWDDetailsApiFp(configuration).processingHistoryAppAWDDetailsGet(id, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryAppAWDDetailsApi - object-oriented interface
 * @export
 * @class ProcessingHistoryAppAWDDetailsApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryAppAWDDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryAppAWDDetailsApi
     */
    public processingHistoryAppAWDDetailsGet(id: string, version: string, options?: any) {
        return ProcessingHistoryAppAWDDetailsApiFp(this.configuration).processingHistoryAppAWDDetailsGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryAppStatusDetailsApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryAppStatusDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentApplicationDetails: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportEnrollmentApplicationDetails.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/applicationstatus/esr/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppStatusDetailsGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryAppStatusDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/applicationstatus/esr`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppStatusDetailsGetApplicationDetailById: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling processingHistoryAppStatusDetailsGetApplicationDetailById.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryAppStatusDetailsGetApplicationDetailById.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/applicationstatus/esr/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryAppStatusDetailsApi - functional programming interface
 * @export
 */
export const ProcessingHistoryAppStatusDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEnrollmentApplicationDetails(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ProcessingHistoryAppStatusDetailsApiAxiosParamCreator(configuration).exportEnrollmentApplicationDetails(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryAppStatusDetailsGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProcessingHistoryEsrAppDetailDto>> {
            const localVarAxiosArgs = await ProcessingHistoryAppStatusDetailsApiAxiosParamCreator(configuration).processingHistoryAppStatusDetailsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryAppStatusDetailsGetApplicationDetailById(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentApplication>> {
            const localVarAxiosArgs = await ProcessingHistoryAppStatusDetailsApiAxiosParamCreator(configuration).processingHistoryAppStatusDetailsGetApplicationDetailById(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryAppStatusDetailsApi - factory interface
 * @export
 */
export const ProcessingHistoryAppStatusDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEnrollmentApplicationDetails(version: string, options?: any): AxiosPromise<any> {
            return ProcessingHistoryAppStatusDetailsApiFp(configuration).exportEnrollmentApplicationDetails(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppStatusDetailsGet(version: string, options?: any): AxiosPromise<PagedProcessingHistoryEsrAppDetailDto> {
            return ProcessingHistoryAppStatusDetailsApiFp(configuration).processingHistoryAppStatusDetailsGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryAppStatusDetailsGetApplicationDetailById(id: string, version: string, options?: any): AxiosPromise<EnrollmentApplication> {
            return ProcessingHistoryAppStatusDetailsApiFp(configuration).processingHistoryAppStatusDetailsGetApplicationDetailById(id, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryAppStatusDetailsApi - object-oriented interface
 * @export
 * @class ProcessingHistoryAppStatusDetailsApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryAppStatusDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryAppStatusDetailsApi
     */
    public exportEnrollmentApplicationDetails(version: string, options?: any) {
        return ProcessingHistoryAppStatusDetailsApiFp(this.configuration).exportEnrollmentApplicationDetails(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryAppStatusDetailsApi
     */
    public processingHistoryAppStatusDetailsGet(version: string, options?: any) {
        return ProcessingHistoryAppStatusDetailsApiFp(this.configuration).processingHistoryAppStatusDetailsGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryAppStatusDetailsApi
     */
    public processingHistoryAppStatusDetailsGetApplicationDetailById(id: string, version: string, options?: any) {
        return ProcessingHistoryAppStatusDetailsApiFp(this.configuration).processingHistoryAppStatusDetailsGetApplicationDetailById(id, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryChartDetailsApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryChartDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryChartDetailsGet: async (version: string, isBusinessTask?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryChartDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/esr/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (isBusinessTask !== undefined) {
                localVarQueryParameter['isBusinessTask'] = isBusinessTask;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryChartDetailsGet2: async (version: string, isBusinessTask?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryChartDetailsGet2.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/emw/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (isBusinessTask !== undefined) {
                localVarQueryParameter['isBusinessTask'] = isBusinessTask;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryChartDetailsApi - functional programming interface
 * @export
 */
export const ProcessingHistoryChartDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryChartDetailsGet(version: string, isBusinessTask?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryChartDetailsDto>> {
            const localVarAxiosArgs = await ProcessingHistoryChartDetailsApiAxiosParamCreator(configuration).processingHistoryChartDetailsGet(version, isBusinessTask, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryChartDetailsGet2(version: string, isBusinessTask?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryChartDetailsDto>> {
            const localVarAxiosArgs = await ProcessingHistoryChartDetailsApiAxiosParamCreator(configuration).processingHistoryChartDetailsGet2(version, isBusinessTask, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryChartDetailsApi - factory interface
 * @export
 */
export const ProcessingHistoryChartDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryChartDetailsGet(version: string, isBusinessTask?: boolean, options?: any): AxiosPromise<ProcessingHistoryChartDetailsDto> {
            return ProcessingHistoryChartDetailsApiFp(configuration).processingHistoryChartDetailsGet(version, isBusinessTask, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {boolean} [isBusinessTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryChartDetailsGet2(version: string, isBusinessTask?: boolean, options?: any): AxiosPromise<ProcessingHistoryChartDetailsDto> {
            return ProcessingHistoryChartDetailsApiFp(configuration).processingHistoryChartDetailsGet2(version, isBusinessTask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryChartDetailsApi - object-oriented interface
 * @export
 * @class ProcessingHistoryChartDetailsApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryChartDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {boolean} [isBusinessTask] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryChartDetailsApi
     */
    public processingHistoryChartDetailsGet(version: string, isBusinessTask?: boolean, options?: any) {
        return ProcessingHistoryChartDetailsApiFp(this.configuration).processingHistoryChartDetailsGet(version, isBusinessTask, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {boolean} [isBusinessTask] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryChartDetailsApi
     */
    public processingHistoryChartDetailsGet2(version: string, isBusinessTask?: boolean, options?: any) {
        return ProcessingHistoryChartDetailsApiFp(this.configuration).processingHistoryChartDetailsGet2(version, isBusinessTask, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryDetailsApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling processingHistoryDetailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/esr/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGet2: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling processingHistoryDetailsGet2.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryDetailsGet2.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/emw/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {ProcessingHistoryStatusCommand} processingHistoryStatusCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGetFileAndScheduleHistoryStatus: async (version: string, processingHistoryStatusCommand: ProcessingHistoryStatusCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryDetailsGetFileAndScheduleHistoryStatus.');
            }
            // verify required parameter 'processingHistoryStatusCommand' is not null or undefined
            if (processingHistoryStatusCommand === null || processingHistoryStatusCommand === undefined) {
                throw new RequiredError('processingHistoryStatusCommand','Required parameter processingHistoryStatusCommand was null or undefined when calling processingHistoryDetailsGetFileAndScheduleHistoryStatus.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/pending/details`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof processingHistoryStatusCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(processingHistoryStatusCommand !== undefined ? processingHistoryStatusCommand : {}) : (processingHistoryStatusCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryDetailsApi - functional programming interface
 * @export
 */
export const ProcessingHistoryDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryDetailsGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryEsrDto>> {
            const localVarAxiosArgs = await ProcessingHistoryDetailsApiAxiosParamCreator(configuration).processingHistoryDetailsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryDetailsGet2(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingHistoryEmwDto>> {
            const localVarAxiosArgs = await ProcessingHistoryDetailsApiAxiosParamCreator(configuration).processingHistoryDetailsGet2(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {ProcessingHistoryStatusCommand} processingHistoryStatusCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryDetailsGetFileAndScheduleHistoryStatus(version: string, processingHistoryStatusCommand: ProcessingHistoryStatusCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingEnrollmentFileStatusDto>> {
            const localVarAxiosArgs = await ProcessingHistoryDetailsApiAxiosParamCreator(configuration).processingHistoryDetailsGetFileAndScheduleHistoryStatus(version, processingHistoryStatusCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryDetailsApi - factory interface
 * @export
 */
export const ProcessingHistoryDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGet(id: string, version: string, options?: any): AxiosPromise<ProcessingHistoryEsrDto> {
            return ProcessingHistoryDetailsApiFp(configuration).processingHistoryDetailsGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGet2(id: string, version: string, options?: any): AxiosPromise<ProcessingHistoryEmwDto> {
            return ProcessingHistoryDetailsApiFp(configuration).processingHistoryDetailsGet2(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {ProcessingHistoryStatusCommand} processingHistoryStatusCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryDetailsGetFileAndScheduleHistoryStatus(version: string, processingHistoryStatusCommand: ProcessingHistoryStatusCommand, options?: any): AxiosPromise<PendingEnrollmentFileStatusDto> {
            return ProcessingHistoryDetailsApiFp(configuration).processingHistoryDetailsGetFileAndScheduleHistoryStatus(version, processingHistoryStatusCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryDetailsApi - object-oriented interface
 * @export
 * @class ProcessingHistoryDetailsApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryDetailsApi
     */
    public processingHistoryDetailsGet(id: string, version: string, options?: any) {
        return ProcessingHistoryDetailsApiFp(this.configuration).processingHistoryDetailsGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryDetailsApi
     */
    public processingHistoryDetailsGet2(id: string, version: string, options?: any) {
        return ProcessingHistoryDetailsApiFp(this.configuration).processingHistoryDetailsGet2(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {ProcessingHistoryStatusCommand} processingHistoryStatusCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryDetailsApi
     */
    public processingHistoryDetailsGetFileAndScheduleHistoryStatus(version: string, processingHistoryStatusCommand: ProcessingHistoryStatusCommand, options?: any) {
        return ProcessingHistoryDetailsApiFp(this.configuration).processingHistoryDetailsGetFileAndScheduleHistoryStatus(version, processingHistoryStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessingHistoryEmwApi - axios parameter creator
 * @export
 */
export const ProcessingHistoryEmwApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryEmwGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling processingHistoryEmwGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/processingHistory/emw`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessingHistoryEmwApi - functional programming interface
 * @export
 */
export const ProcessingHistoryEmwApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processingHistoryEmwGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedEmwProcessingHistory>> {
            const localVarAxiosArgs = await ProcessingHistoryEmwApiAxiosParamCreator(configuration).processingHistoryEmwGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessingHistoryEmwApi - factory interface
 * @export
 */
export const ProcessingHistoryEmwApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processingHistoryEmwGet(version: string, options?: any): AxiosPromise<PagedEmwProcessingHistory> {
            return ProcessingHistoryEmwApiFp(configuration).processingHistoryEmwGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessingHistoryEmwApi - object-oriented interface
 * @export
 * @class ProcessingHistoryEmwApi
 * @extends {BaseAPI}
 */
export class ProcessingHistoryEmwApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessingHistoryEmwApi
     */
    public processingHistoryEmwGet(version: string, options?: any) {
        return ProcessingHistoryEmwApiFp(this.configuration).processingHistoryEmwGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProductTypeApi - axios parameter creator
 * @export
 */
export const ProductTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTypeGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling productTypeGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/geAllProductType`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTypeApi - functional programming interface
 * @export
 */
export const ProductTypeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTypeGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await ProductTypeApiAxiosParamCreator(configuration).productTypeGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductTypeApi - factory interface
 * @export
 */
export const ProductTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTypeGet(version: string, options?: any): AxiosPromise<Array<string>> {
            return ProductTypeApiFp(configuration).productTypeGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTypeApi - object-oriented interface
 * @export
 * @class ProductTypeApi
 * @extends {BaseAPI}
 */
export class ProductTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypeApi
     */
    public productTypeGet(version: string, options?: any) {
        return ProductTypeApiFp(this.configuration).productTypeGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TotalRecordsChartDetailsApi - axios parameter creator
 * @export
 */
export const TotalRecordsChartDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalRecordsChartDetailsGet: async (version: string, employerName?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling totalRecordsChartDetailsGet.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/esrCharts/totalRecords/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (employerName !== undefined) {
                localVarQueryParameter['employerName'] = employerName;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalRecordsChartDetailsGet2: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling totalRecordsChartDetailsGet2.');
            }
            const localVarPath = `/api/v{version}/enrollmentFiles/totalRecordsChart/esr/chartDetails`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TotalRecordsChartDetailsApi - functional programming interface
 * @export
 */
export const TotalRecordsChartDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalRecordsChartDetailsGet(version: string, employerName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TotalRecordsChartDetailsDto>>> {
            const localVarAxiosArgs = await TotalRecordsChartDetailsApiAxiosParamCreator(configuration).totalRecordsChartDetailsGet(version, employerName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalRecordsChartDetailsGet2(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TotalRecordsChartDetailsDto>>> {
            const localVarAxiosArgs = await TotalRecordsChartDetailsApiAxiosParamCreator(configuration).totalRecordsChartDetailsGet2(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TotalRecordsChartDetailsApi - factory interface
 * @export
 */
export const TotalRecordsChartDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [employerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalRecordsChartDetailsGet(version: string, employerName?: string, options?: any): AxiosPromise<Array<TotalRecordsChartDetailsDto>> {
            return TotalRecordsChartDetailsApiFp(configuration).totalRecordsChartDetailsGet(version, employerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalRecordsChartDetailsGet2(version: string, options?: any): AxiosPromise<Array<TotalRecordsChartDetailsDto>> {
            return TotalRecordsChartDetailsApiFp(configuration).totalRecordsChartDetailsGet2(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TotalRecordsChartDetailsApi - object-oriented interface
 * @export
 * @class TotalRecordsChartDetailsApi
 * @extends {BaseAPI}
 */
export class TotalRecordsChartDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [employerName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotalRecordsChartDetailsApi
     */
    public totalRecordsChartDetailsGet(version: string, employerName?: string, options?: any) {
        return TotalRecordsChartDetailsApiFp(this.configuration).totalRecordsChartDetailsGet(version, employerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TotalRecordsChartDetailsApi
     */
    public totalRecordsChartDetailsGet2(version: string, options?: any) {
        return TotalRecordsChartDetailsApiFp(this.configuration).totalRecordsChartDetailsGet2(version, options).then((request) => request(this.axios, this.basePath));
    }

}


